<template>
  <div class="home">
    <div id="MyViewerDiv" class="model" v-show="modelShow"></div>

    <canvas id="snapshot" hidden></canvas>

    <el-select v-model="model2dpath" @change="change2d" v-if="model2dpath"
      style="position: absolute; top: 94vh; left: 2%">
      <el-option v-for="item in model2d" :key="item.tdmd03" :label="item.tdmd03" :value="item.tdmd04">
      </el-option>
    </el-select>
    <div class="file_icon_container flexLR">
      <div>
        <el-tooltip class="item" effect="dark" :content="$t('common.添加批注')" placement="top">
          <img src="/img/ktr_icon/file_icon/pz.png" width="22" @click="click_pz" @mouseover="hoverImage1($event)"
            @mouseleave="leaveImage1($event)" class="icon_1" alt="" />
        </el-tooltip>
      </div>
      <div>
        <el-tooltip class="item" effect="dark" :content="$t('common.批注列表')" placement="top">
          <img src="/img/ktr_icon/file_icon/lb.png" width="22" @click="click_lb" @mouseover="hoverImage2($event)"
            @mouseleave="leaveImage2($event)" class="icon_2" alt="" />
        </el-tooltip>
      </div>
    </div>
    <div id="editor" v-show="officeShow"></div>
    <!-- <div v-show="iframeShow" id="pdfShow">

      <div class="controls">
        <span style="color:white;font-size: 18px;font-weight: bold;position: absolute;left: 1%;">{{ locationParams.name
        }}</span>
        <el-button style="width: 80px;" :disabled="prevDisable" type="primary" @click="prevPage()">
          上一页
        </el-button>
        <el-input-number v-model="currentPage" controls-position="right" @change="jumpToPage"
          @keyup.enter.native="jumpToPage" :min="1" :max="totalPages" style="width: 80px;"></el-input-number>
        <span style="color:white;font-size: 28px;font-weight: bold;">/</span>
        <el-input readonly :value="totalPages" style="width: 60px;"></el-input>
        <el-button style="width: 80px;" :disabled="nextDisable" type="primary" @click="nextPage()">
          下一页
        </el-button>
        <el-select @change="changeZoom" v-model="zoomSelect" style="width: 100px;line-height: 50px;">
          <el-option label="10%" :value="0.1"></el-option>
          <el-option label="30%" :value="0.3"></el-option>
          <el-option label="50%" :value="0.5"></el-option>
          <el-option label="75%" :value="0.75"></el-option>
          <el-option label="100%" :value="1"></el-option>
          <el-option label="125%" :value="1.25"></el-option>
          <el-option label="150%" :value="1.5"></el-option>
          <el-option label="200%" :value="2"></el-option>
        </el-select>
      </div>

      <div class="pdf-container" id="pdfContainer">
        <div class="pdf-content" id="pdfContent"></div>
      </div>

    </div> -->

    <div v-show="iframeShow" style="width: 100%;height: 100%;">
      <iframe :src="iframeUrl" width="100%" height="100%" style="width: 100%;height: 100vh;border: none;"></iframe>
    </div>

    <div v-if="imgShow"
      style="width: 100%;height: 100%;overflow: auto;display: flex;justify-content: center;align-items: center;">
      <img v-if="imgShow" :src="iframeUrl" style="height: 100%;" />
    </div>
    <video id="myVideo" controls v-show="videoShow">
      <source :src="iframeUrl" type="video/mp4" />
      <p>
        您的浏览器不支持HTML5视频，请使用现代浏览器如Chrome、Firefox或Edge。
      </p>
    </video>
    <MyDialog :visible="mydialogVisible" @update:visible="(val) => resetForm(val)" :title="$t('common.创建批注')">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="90px" class="demo-ruleForm">
        <el-form-item :label="$t('common.问题截图')">
          <el-upload action="#" list-type="picture-card" class="myupload" :on-change="handleChange"
            :on-preview="handlePictureCardPreview" :file-list="form.files.length ? form.files.filter((x) => x.type == 1) : []
              " :auto-upload="false" :on-remove="handleRemove">
          </el-upload>

          <el-popover placement="bottom-start" title="" width="200" trigger="hover">
            <div v-if="showTips">
              <p>
                1.{{ $t("pzlb.打开当前浏览器在地址栏输入") }}<br />
                <span style="color: red">chrome://flags/#unsafely-treat-insecure-origin-as-secure</span><br />
                <el-button type="text" @click="
                  copyToClipboard(
                    'chrome://flags/#unsafely-treat-insecure-origin-as-secure'
                  )
                  " size="mini">{{ $t("pzlb.复制地址") }}</el-button>
              </p>
              <p>
                2.{{
                  $t(
                    "pzlb.在打开的界面中下拉框选择enabled地址填写你的项目访问路径"
                  )
                }}
              </p>
              <el-button type="text" @click="copyToClipboard('window')" size="mini">{{ $t("pzlb.复制访问路径") }}</el-button>
              <el-image style="width: 200px" src="../img/screenshot.png"
                :preview-src-list="['../img/screenshot.png']"></el-image>
            </div>
            <div v-else>
              {{ $t("pzlb.点击截图自动上传") }}
            </div>
            <div class="el-upload--picture-card" @click="screenshot" slot="reference" style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 40px;
                width: 100%;
              ">
              <i class="el-icon-plus" style="font-size: 14px"></i>
            </div>
          </el-popover>
        </el-form-item>

        <el-form-item :label="$t('common.问题描述')" prop="description">
          <el-input type="textarea" v-model="form.description"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.审图要点')">
          <!-- <el-button size="mini" type="primary" plain>关联审图要点</el-button> -->
          <el-cascader size="medium" v-model="form.point" :options="checkList" :placeholder="$t('common.请先选择')"
            :collapse-tags="false" filterable :props="{
              label: 'name',
              value: 'name',
              expandTrigger: 'click',
              emitPath: false,
            }">
            <template slot-scope="{ node, data }">
              <el-tooltip class="item" effect="dark" :content="data.name" placement="top-start">
                <span>{{ data.name }}</span>
              </el-tooltip>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
          <el-input type="textarea" style="margin-top: 5px" v-model="form.point" readonly></el-input>
        </el-form-item>
        <el-form-item :label="$t('pzlb.关联文件')">
          <div class="flexLR">
            <el-cascader :options="fileList" ref="myCascader" v-model="cascaderModel" @change="fileOnChange"
              size="small" :placeholder="$t('common.请先选择')" :show-all-levels="false" :collapse-tags="true" clearable
              filterable :props="{
                label: 'Name',
                value: 'Name',
                expandTrigger: 'click',
                emitPath: false,
                multiple: true,
              }">
              <template slot-scope="{ node, data }">
                <el-tooltip class="item" effect="dark" :content="data.Name" placement="top-start">
                  <span>{{ data.Name }}</span>
                </el-tooltip>
                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
              </template>
            </el-cascader>
            <el-button type="primary" size="medium" @click="
              () => {
                $refs.uploadRef.$el.querySelector('input').click();
              }
            " style="margin-left: 10px" plain>{{ $t("common.本地上传") }}</el-button>
          </div>

          <el-upload action="#" ref="uploadRef" :on-change="handleChange2"
            :file-list="form.files.length ? form.files.filter((x) => x.type == 2) : []" :auto-upload="false"
            :on-remove="handleRemove2">
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('common.问题类型')">
          <el-select size="small" style="width: 100%" filterable v-model="form.type" popper-class="select-option"
            :placeholder="$t('common.请先选择')">
            <el-option v-for="item in wtOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('common.专业')">
          <el-select size="small" style="width: 100%" multiple filterable v-model="form.major"
            popper-class="select-option" :placeholder="$t('common.请先选择')">
            <el-option v-for="item in zyOptions" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="this.$t('common.修改方')">
          <el-cascader :options="userList" :placeholder="$t('common.请先选择')" v-model="form.modifyUsers"
            :show-all-levels="true" :collapse-tags="true" clearable filterable :props="{
              label: 'Name',
              value: 'Id',
              expandTrigger: 'click',
              emitPath: false,
              multiple: true,
              emitPath: false,
            }">
            <template slot-scope="{ node, data }">
              <el-tooltip class="item" effect="dark" :content="data.Name" placement="top-start">
                <span>{{ data.Name }}</span>
              </el-tooltip>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item :label="$t('common.位置')">
          <el-input v-model="form.location" :placeholder="$t('common.请先选择')" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <div style="display: flex; justify-content: right">
            <el-button size="small" type="success" v-if="modelShow" @click="tuya">{{ $t("common.涂鸦") }}</el-button>
            <el-button size="small" @click="resetForm">{{
              $t("common.清空")
            }}</el-button>
            <el-button size="small" type="primary" @click="submitForm('ruleForm')">{{ $t("common.创建") }}</el-button>
          </div>
        </el-form-item>
      </el-form>
    </MyDialog>
    <MyDialog class="dialog2" :visible="mydialogVisible2" @update:visible="mydialogVisible2Close"
      :title="$t('common.批注列表')" :initialPosition="initPosition" :width="420">
      <el-input :placeholder="$t('common.请输入搜索内容')" v-model="search" style="width: 100%; margin-bottom: 10px"
        @input="fuzzyQuery" clearable>
      </el-input>
      <el-descriptions class="margin-top" :class="activeListIndex == index ? 'activeList' : 'inactivityList'"
        style="background-color: #ebf9ff" v-for="(item, index) in pzList" :key="index" :column="2" size="small">
        <template slot="title">
          <el-dropdown :popper-append-to-body="false" trigger="click"
            @command="(val) => updateStatus(val, item, index)">
            <span class="el-dropdown-link">
              <span :style="{
                color:
                  item.status == '已修改'
                    ? '#22b14c'
                    : item.status == '不修改'
                      ? '#00a2e8'
                      : item.status == '已销项'
                        ? '#000000'
                        : item.status == '待修改'
                          ? '#ed1c24'
                          : 'red',
                fontWeight: 500,
              }" @click="openParticulars(item, index)">[ {{ $t("pzlb." + item.status) }} ]</span><i
                class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" class="mydropdown">
              <el-dropdown-item command="待修改" :disabled="item.status == '待修改'">{{ $t("pzlb.待修改") }}</el-dropdown-item>
              <el-dropdown-item command="已修改" :disabled="item.status == '已修改'">{{ $t("pzlb.已修改") }}</el-dropdown-item>
              <el-dropdown-item command="不修改" :disabled="item.status == '不修改'">{{ $t("pzlb.不修改") }}</el-dropdown-item>
              <el-dropdown-item command="已销项" :disabled="item.status == '已销项'">{{ $t("pzlb.已销项") }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="text" @click="openParticulars(item, index)" style="margin-left: 5px; font-weight: bold">{{
            item.description }}</el-button>
        </template>
        <template slot="extra" v-if="item.userId == uid">
          <i class="el-icon-delete" @click="delComment(item, index)" style="font-size: 20px; cursor: pointer"></i>
        </template>
        <el-descriptions-item :label="$t('common.修改方')">
          <div @click="
            () => {
              activeListIndex = index;
            }
          ">
            {{
              item.modifyname && item.modifyname.length > 0
                ? item.modifyname
                : "无"
            }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('common.创建时间')">
          <div @click="
            () => {
              activeListIndex = index;
            }
          ">
            {{ item.time }}
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </MyDialog>
    <MyDialog class="dialog3" :visible="mydialogVisible3" @update:visible="(val) => (mydialogVisible3 = val)"
      :title="$t('common.批注详情')" :initialPosition="initPosition3" :width="400">
      <el-tabs v-model="activeName" @tab-click="tabsClick">
        <el-tab-pane :label="$t('common.内容')" name="first" style="height: 670px; overflow-y: auto">
          <div v-if="
            activeItem &&
            (uid == activeItem.userId ||
              (activeItem.modifyUsers &&
                activeItem.modifyUsers.split(',').includes(uid)))
          ">
            问题回复
            <el-input :placeholder="$t('common.请输入内容')" :maxlength="200" :rows="4" type="textarea" v-model="reply"
              style="width: 100%; margin: 10px 0" clearable>
              <template #suffix></template>
              <template #append></template>
            </el-input>
            <div style="margin-bottom: 10px; display: flex; justify-content: right">
              <el-button type="primary" size="small" @click="postMessage">{{
                $t("common.发表回复")
              }}</el-button>
            </div>
          </div>

          <div class="line"></div>

          <div>
            <!-- <el-image @click="resview(item)"  v-for="(item, index) in activeItem ? activeItem.files.filter(item => item.type == 1) : []" :key="index"
              :preview-src-list="activeItem ? activeItem.files.filter(item => item.type == 1).map(item => $store.state.baseUrl + item.url) : []"
              style="width: 115px; height: 100px;margin:0 10px 10px 0;" :src="$store.state.baseUrl + item.url">
            </el-image> -->

            <el-carousel :autoplay="false" type="card" height="150px">
              <el-carousel-item v-for="(item, index) in activeItem
                ? activeItem.files.filter((item) => item.type == 1)
                : []" :key="index">
                <el-image @click="resview(item)" :preview-src-list="activeItem
                  ? activeItem.files
                    .filter((item) => item.type == 1)
                    .map((item) => $store.state.baseUrl + item.url)
                  : []
                  " style="width: 300px; height: 150px" :src="$store.state.baseUrl + item.url">
                </el-image>
              </el-carousel-item>
            </el-carousel>
          </div>

          <el-descriptions class="margin-top" v-if="activeItem" style="padding-bottom: 40px" :column="1">
            <el-descriptions-item :label="$t('common.所属文件')">{{
              activeItem.projectfile ? activeItem.projectfile.prfl02 : "--"
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('common.问题状态')">
              <span :style="{
                color:
                  activeItem.status == '已修改'
                    ? '#22b14c'
                    : activeItem.status == '不修改'
                      ? '#00a2e8'
                      : activeItem.status == '已销项'
                        ? '#000000'
                        : activeItem.status == '待修改'
                          ? '#ed1c24'
                          : 'red',
                fontWeight: 500,
              }">{{ $t("pzlb." + activeItem.status) }}</span>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('common.问题描述')">{{
              activeItem.description
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('common.审图要点')">{{
              activeItem.point
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('pzlb.关联文件')">
              <!-- <el-upload action="#" ref="uploadRefInfo" :on-preview="handlePreviewInfo"
                :file-list="activeItem.files.length ? activeItem.files.filter(item => item.type == 2) : []"
                :auto-upload="false" disabled tip="点击下载">
              </el-upload> -->
              <!-- <el-table :data="activeItem.files.length ? activeItem.files.filter(item => item.type == 2) : []" >
                <el-table-column style="height:10px" prop="name" label="名称" align="center">
                </el-table-column>
                <el-table-column prop="name" label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" class="el-icon-download" ></el-button>ed
                  </template>
                </el-table-column>
              </el-table> -->

              <div style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding-right: 10px;
                  margin-bottom: 5px;
                " v-for="item in activeItem.files.length
                  ? activeItem.files.filter((item) => item.type == 2)
                  : []" :key="item.id">
                <span>{{ item.name }}</span>
                <i class="el-icon-download" style="color: #409eff; cursor: pointer"
                  @click="handlePreviewInfo(item)"></i>
              </div>
            </el-descriptions-item>
            <el-descriptions-item :label="$t('common.问题类型')">{{
              $t("pzlb." + activeItem.type)
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('common.修改方')">{{
              activeItem.modifyname
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('common.创建人')">{{
              activeItem.creatname
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('common.创建时间')">{{
              activeItem.time
            }}</el-descriptions-item>
            <el-descriptions-item :label="$t('common.位置')">{{
              activeItem.location ? activeItem.location : "--"
            }}</el-descriptions-item>
          </el-descriptions>
          <!-- <el-button type="primary" size="default" style="width: 100%;position: fixed;bottom: 0;left: 0;">修改</el-button> -->
        </el-tab-pane>

        <el-tab-pane :label="$t('common.活动')" name="second" style="height: 670px; overflow-y: auto">
          <el-timeline>
            <el-timeline-item v-for="item in RecordList" :key="item.id" :timestamp="item.time" placement="top">
              <el-card>
                <h4>{{ item.username }}</h4>
                <p>{{ $t("common.状态") }}：{{ $t("pzlb." + item.state) }}</p>
                <p>{{ $t("common.内容") }}：{{ item.content }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
      </el-tabs>
    </MyDialog>

    <el-dialog :z-index="99999999" :title="$t('common.图片预览')" :visible.sync="lookImgDialog">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <!-- 云线输入弹窗 -->
    <div id="cloudInputModal">
      <h3>{{ $t('common.请输入内容') }}</h3>
      <input type="text" id="cloudInputText" :placeholder="$t('common.请输入内容')" />
      <div class="button-group">
        <button class="btn-cancel" id="cloudInputCancel">{{ $t('common.取消') }}</button>
        <button class="btn-confirm" id="cloudInputConfirm">{{ $t('common.确定') }}</button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  Office2Pdf,
  GetOneUploadFile,
  GetCheckList,
  GetFileTreeWithFiles,
  GetDeptWithUser2,
  AddComment,
  GetComment,
  DelComment,
  ChangeCommentState,
  AddCommentRecord,
  GetCommentRecord,
} from "@/setAxios";
import ScreenShot from "js-web-screen-shot";
import MyDialog from "@/components/Customization/dialog/index";
import Template from "./project/ProjectSettings/barCode/template.vue";
import kte_checklist_zh from "../../public/ConfigSetting/kte_checklist_zh.js";
import kte_checklist_en from "../../public/ConfigSetting/kte_checklist_en.js";
import { wtOptions_zh, wtOptions_en } from "../../public/ConfigSetting/wtOptions.js";
import { zyOptions_zh, zyOptions_en } from "../../public/ConfigSetting/zyOptions.js";


export default {
  name: "viewFileModel",
  components: { MyDialog },
  data() {
    Template;
    return {
      isFinishMultiDrawing: false,
      // pdf参数
      zoomSelect: 1,
      prevDisable: true,
      nextDisable: true,
      totalPages: 0,
      currentPage: 1,
      pdfDoc: null,


      model2dpath: null,
      addLiveActionUrl: this.$store.state.baseUrl + "/api/UploadModelLable",
      importHeaders: { token: localStorage.getItem("token") },
      url: "",
      uid: "",
      activeName: "first",
      // 批注列表模糊查询
      search: "",
      // 批注详情回复
      reply: "",
      search: "",
      cascaderModel: [],
      // 批注点击目标的详情数据
      activeItem: null,
      locationParams: {},
      initPosition: { x: window.innerWidth - 440, y: 0 },
      initPosition3: { x: 15, y: 0 },
      viewer: null,
      //模型显示
      modelShow: false,
      //onlyoffice
      officeShow: false,
      //图片显示
      imgShow: false,
      //视频显示
      videoShow: false,
      //iframe显示
      iframeShow: false,
      // 自定义弹出框
      mydialogVisible: false,
      mydialogVisible2: false,
      mydialogVisible3: false,
      exts: [
        "png",
        "jpg",
        "jpeg",
        "mp4",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "ppt",
        "pptx",
        "txt",
        "gif",
        "pdf",
      ],
      modelexts: [
        "nwd", "nwf", "nwc",
        "rvt", "rfa",
        "model", "session", "exp", "dlw3", "catpart", "catproduct", "cgr",
        "dgn", "prp", "prw",
        "dwg", "dxf",
        "fbx", "ifc", "3dm", "skp",
        "prt", "sldprt", "asm", "sldasm"
      ],
      iframeUrl: "",
      // 查看图片url
      dialogImageUrl: "",
      //form
      form: {
        cid: localStorage.pid,
        fileId: "",
        userId: localStorage.id,
        xid: "",
        status: "待修改",
        files: [],
        cacheFiles: [],
        description: "",
        point: "",
        type: "",
        major: [],
        modifyUsers: "",
        location: "",
      },
      rules: {
        description: [
          {
            required: true,
            message: this.$t("common.请输入内容"),
            trigger: "blur",
          },
        ],
      },
      // 查看图片弹窗
      lookImgDialog: false,
      wtOptions: localStorage.lang == 'zh' ? wtOptions_zh : wtOptions_en,
      zyOptions: localStorage.lang == 'zh' ? zyOptions_zh : zyOptions_en,
      //审图要点
      checkList: [],
      //文件列表
      fileList: [],
      //用户列表
      userList: [],
      // 批注列表
      pzList: [],
      AllPzList: [],
      // 活动内容列表
      RecordList: [],
      //当前文件详情
      OneUploadFileData: {},
      // 批注列表选中高亮显示index
      activeListIndex: -1,

      showTips: false,
      markupExt: null,
      LINE_STYLE: {
        stroke: '#ff0000', // 直线颜色
        strokeWidth: '1', // 直线宽度（像素）
        strokeDasharray: '5,5' // 虚线样式（绘制时），'none' 表示实线（完成时）
      },
      TEXT_STYLE: {
        fontSize: '10', // 文字大小（像素）
        fill: '#ff0000', // 文字颜色
        textAnchor: 'start', // 文字锚点：'start'左对齐, 'middle'居中, 'end'右对齐
        dominantBaseline: 'middle' // 文字基线：'middle'垂直居中, 'top'顶部对齐, 'bottom'底部对齐
      },
    };
  },
  methods: {


    mydialogVisible2Close() {
      this.mydialogVisible2 = false;
      try {
        document.getElementsByName('cancel')[0].nextElementSibling.click()
      } catch (error) { }
    },
    tuya() {
      if (document.getElementsByClassName("docking-markup").length) return;
      /*** 定义button按钮对象 **/
      var viewer = this.viewer;
      viewer.unloadExtension("Autodesk.Viewing.MarkupsCore");
      viewer.loadExtension("Autodesk.Viewing.MarkupsCore").then(() => {
        var config = {
          markupDisableHotkeys: false,
        };
        bimViewPointNew.markup =
          new Autodesk.Viewing.Extensions.Markups.Core.MarkupsCore(
            viewer,
            config
          );
        bimViewPointNew.markup.load();
        bimViewPointNew.enterViewMode();
        viewer.unloadExtension(
          "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
        );
        viewer.loadExtension(
          "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
        );
        bimViewPointNew.toolPanel =
          viewer.loadedExtensions[
            "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
          ].getToolPanel();
        // setTimeout(() => {

        $('[id$="lace"]')[0].click();

        //dwg单独处理
        // if (this.locationParams.path
        //   .substring(this.locationParams.path.lastIndexOf(".") + 1)
        //   .toLowerCase() == "dwg") {
        // try {
        //   document.getElementsByClassName("docking-markup")[0].style.display = "none";
        //   document.getElementById("guiviewer3d-toolbar").style.display = "block";
        // } catch (error) { }
        this.initDwgTuya();
        // }

        // }, 100);
      });
    },
    initDwgTuya() {
      var _this = this;
      var markupExt = bimViewPointNew.markup;
      this.markupExt = markupExt;
      var currentCloudMarkup = null // 当前创建的云线
      var isDrawingLine = false // 是否正在绘制线
      var tempLine = null // 临时绘制的线
      var lineStartPoint = null // 线的起点
      var lineEndPoint = null // 线的终点
      var lineText = null // 线的文本内容
      var tempLineElement = null // 临时线的SVG元素
      var tempTextElement = null // 临时文本的SVG元素

      // ==================== 绘制模式配置 ====================
      // 绘制模式：'one-to-one' 一对一绘制，'many-to-one' 多对一绘制
      var drawMode = 'many-to-one'
      var cloudMarkups = [] // 多对一模式下收集的云线数组
      var isMultiDrawing = false // 是否正在多对一绘制模式
      var multiLineElements = [] // 多对一模式下的多条线元素
      var multiTextElements = [] // 多对一模式下的多个文本元素

      // ==================== 云线与直线关联关系 ====================
      // 存储云线和直线的关联关系：{ cloudMarkupId: [{lineElement, textElement, endPoint}] }

      window.viewer = this.viewer;
      var cloudLineMap = {}

      var GUIDE_ORPHAN_REMOVE_DELAY = 5000; // ms

      function getDefaultLayerName(preferredLayerName) {
        if (preferredLayerName) {
          return preferredLayerName;
        }
        if (markupExt && markupExt.activeLayer) {
          return markupExt.activeLayer;
        }
        if (markupExt && markupExt.svgLayersMap) {
          for (var layerName in markupExt.svgLayersMap) {
            if (markupExt.svgLayersMap.hasOwnProperty(layerName)) {
              return layerName;
            }
          }
        }
        return null;
      }

      function ensureGuideElementsAttached(lineData) {
        if (!lineData || !lineData.lineElement) {
          return false;
        }
        var lineAttached = !!(lineData.lineElement && lineData.lineElement.parentNode);
        var textAttached = !lineData.textElement || !!lineData.textElement.parentNode;
        if (lineAttached && textAttached) {
          lineData._detachTime = null;
          return true;
        }

        var targetLayerName = getDefaultLayerName(lineData.layerName);
        var svgContainer = getActiveSvgContainer(targetLayerName);
        if (!svgContainer) {
          var layerNode = document.querySelector('[layer-order-id="markups-svg"]');
          if (layerNode) {
            if (layerNode.tagName && layerNode.tagName.toLowerCase() === 'svg') {
              svgContainer = layerNode;
            } else {
              var childSvg = layerNode.querySelector('svg');
              if (childSvg) {
                svgContainer = childSvg;
              }
            }
          }
        }

        if (!svgContainer) {
          if (!lineData._detachTime) {
            lineData._detachTime = Date.now();
          }
          return false;
        }

        if (!lineAttached && lineData.lineElement) {
          svgContainer.appendChild(lineData.lineElement);
          lineAttached = true;
        }
        if (!textAttached && lineData.textElement) {
          svgContainer.appendChild(lineData.textElement);
          textAttached = true;
        }

        if (lineAttached && textAttached) {
          lineData._detachTime = null;
          return true;
        }

        if (!lineData._detachTime) {
          lineData._detachTime = Date.now();
        }
        return false;
      }

      // ==================== 样式配置常量 ====================
      // 直线样式配置
      var LINE_STYLE = _this.LINE_STYLE

      // 文字样式配置
      var TEXT_STYLE = _this.TEXT_STYLE

      // 文字位置配置
      var TEXT_POSITION = {
        offset: 8, // 文字与终点的距离（像素）
        offsetX: 0, // 文字X轴偏移（多对一模式）
        offsetY: 0 // 文字Y轴偏移（多对一模式，负值表示向上）
      };

      function getAllCloudMarkups() {
        if (!markupExt || !markupExt.markups) return [];
        var result = [];
        for (var i = 0; i < markupExt.markups.length; i++) {
          var m = markupExt.markups[i];
          if (m && (m.type === 'cloud' || m.type === 'cloudrect' || (m.constructor && m.constructor.name && m
            .constructor.name.indexOf('Cloud') >= 0))) {
            var bbox = null;
            var tag = null;
            var d = null;
            if (m.shape) {
              try {
                bbox = m.shape.getBBox();
              } catch (e) {
                bbox = null;
              }
              tag = m.shape.tagName || null;
              if (m.shape.getAttribute) d = m.shape.getAttribute('d') || null;
            }
            result.push({
              id: m.id,
              type: m.type,
              bbox: bbox ? {
                x: bbox.x,
                y: bbox.y,
                width: bbox.width,
                height: bbox.height
              } : null,
              shape: {
                tag: tag,
                d: d
              }
            });
          }
        }
        return result;
      }

      function getMarkupById(cloudId) {
        if (!markupExt || !markupExt.markups) return null;
        for (var i = 0; i < markupExt.markups.length; i++) {
          var markup = markupExt.markups[i];
          if (!markup || markup.id == null) continue;
          if (String(markup.id) === String(cloudId)) {
            return markup;
          }
        }
        return null;
      }

      function getMarkupBBox(cloudId) {
        var markup = getMarkupById(cloudId);
        if (!markup) return null;
        var bbox = null;
        if (markup.shape && markup.shape.getBBox) {
          try {
            var raw = markup.shape.getBBox();
            bbox = {
              x: raw.x,
              y: raw.y,
              width: raw.width,
              height: raw.height
            };
          } catch (e) { }
        }
        if (!bbox && markup._cloudBBox) {
          bbox = {
            x: markup._cloudBBox.x,
            y: markup._cloudBBox.y,
            width: markup._cloudBBox.width,
            height: markup._cloudBBox.height
          };
        } else if (bbox) {
          markup._cloudBBox = bbox;
        }
        return bbox;
      }

      function setMarkupBBox(cloudId, bbox) {
        if (!bbox) return;
        var markup = getMarkupById(cloudId);
        if (markup) {
          markup._cloudBBox = {
            x: bbox.x,
            y: bbox.y,
            width: bbox.width,
            height: bbox.height
          };
        }
      }

      function getGuideLinesData() {
        var data = {};
        for (var cloudId in cloudLineMap) {
          if (!cloudLineMap.hasOwnProperty(cloudId)) continue;
          var list = cloudLineMap[cloudId] || [];
          if (!data[cloudId]) {
            data[cloudId] = {
              cloudBBox: getMarkupBBox(cloudId),
              guides: []
            };
          }

          var target = data[cloudId];
          if (!target.guides) {
            target.guides = [];
          }
          if (!target.cloudBBox) {
            target.cloudBBox = getMarkupBBox(cloudId);
          }
          for (var i = 0; i < list.length; i++) {
            var it = list[i];
            if (!it || !it.lineElement) continue;
            var x1 = parseFloat(it.lineElement.getAttribute('x1')) || 0;
            var y1 = parseFloat(it.lineElement.getAttribute('y1')) || 0;
            var x2 = parseFloat(it.lineElement.getAttribute('x2')) || 0;
            var y2 = parseFloat(it.lineElement.getAttribute('y2')) || 0;
            var txt = null,
              tx = null,
              ty = null;
            if (it.textElement) {
              txt = it.textElement.textContent || '';
              tx = parseFloat(it.textElement.getAttribute('x')) || 0;
              ty = parseFloat(it.textElement.getAttribute('y')) || 0;
            }
            target.guides.push({
              line: {
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2
              },
              text: {
                content: txt,
                x: tx,
                y: ty
              }
            });
          }
        }
        return data;
      }


      function importAnnotationsFromJSON(jsonStr) {
        var data = null;
        try {
          data = JSON.parse(jsonStr);
        } catch (e) {
          alert('JSON 解析失败');
          return;
        }
        if (!data) return;
        restoreAll(data);
      }

      function getActiveSvgContainer(preferredLayerName) {
        if (!markupExt) return null;
        var svgContainer = null;

        if (preferredLayerName && markupExt.svgLayersMap) {
          var preferredLayer = markupExt.svgLayersMap[preferredLayerName];
          if (preferredLayer && preferredLayer.svg) {
            svgContainer = preferredLayer.svg;
          }
        }

        if (!svgContainer && markupExt.editModeSvgLayerNode && markupExt.editModeSvgLayerNode.svg) {
          svgContainer = markupExt.editModeSvgLayerNode.svg;
        }

        if (!svgContainer && markupExt.svgLayersMap && markupExt.activeLayer) {
          var layer = markupExt.svgLayersMap[markupExt.activeLayer];
          if (layer && layer.svg) svgContainer = layer.svg;
        }
        return svgContainer;
      }
      var restoreIds = {}

      function restoreGuideLines(guides, targetLayerName, retryCount) {
        if (!guides) return;
        retryCount = retryCount || 0;

        var svgContainer = markupExt.svg
        if (!svgContainer) {
          // 尝试获取SVG容器
          svgContainer = getActiveSvgContainer(targetLayerName);
          if (!svgContainer) {
            var layerNode = document.querySelector('[layer-order-id="markups-svg"]');
            if (layerNode) {
              if (layerNode.tagName && layerNode.tagName.toLowerCase() === 'svg') {
                svgContainer = layerNode;
              } else {
                var childSvg = layerNode.querySelector('svg');
                if (childSvg) {
                  svgContainer = childSvg;
                }
              }
            }
          }
        }

        if (!svgContainer) {
          if (retryCount < 8) {
            setTimeout(function () {
              restoreGuideLines(guides, targetLayerName, retryCount + 1);
            }, 150);
          } else {
            console.warn('无法恢复指引线：未找到 SVG 容器');
          }
          return;
        }

        // 检查SVG容器是否有Y轴翻转
        var svgTransform = '';
        if (svgContainer.getAttribute('transform')) {
          svgTransform = svgContainer.getAttribute('transform');
        }
        if (!svgTransform && svgContainer.style && svgContainer.style.transform) {
          svgTransform = svgContainer.style.transform;
        }
        if (!svgTransform && window.getComputedStyle) {
          var computedStyle = window.getComputedStyle(svgContainer);
          if (computedStyle.transform && computedStyle.transform !== 'none') {
            svgTransform = computedStyle.transform;
          }
        }

        var hasYFlip = svgTransform.includes('scale(1, -1)') ||
          svgTransform.includes('scale(1,-1)') ||
          (svgTransform.includes('matrix') && svgTransform.includes('-1'));

        var textCache = new Map();
        for (var cloudId in guides) {
          if (!guides.hasOwnProperty(cloudId)) continue;
          var entryData = guides[cloudId];
          if (!entryData) continue;

          var entries = null;
          var cloudBBox = null;
          if (Array.isArray(entryData)) {
            entries = entryData;
          } else if (entryData.guides && Array.isArray(entryData.guides)) {
            entries = entryData.guides;
            cloudBBox = entryData.cloudBBox || entryData.bbox || null;
          } else if (entryData.line) {
            entries = [entryData];
          }

          if (!entries || !entries.length) continue;
          if (cloudBBox) {
            setMarkupBBox(cloudId, cloudBBox);
          }
          if (!cloudLineMap[cloudId]) cloudLineMap[cloudId] = [];
          for (var gi = 0; gi < entries.length; gi++) {
            var g = entries[gi];
            if (!g || !g.line) continue;
            var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
            line.setAttribute('x1', g.line.x1);
            line.setAttribute('y1', g.line.y1);
            line.setAttribute('x2', g.line.x2);
            line.setAttribute('y2', g.line.y2);
            line.setAttribute('stroke', LINE_STYLE.stroke);
            line.setAttribute('stroke-width', LINE_STYLE.strokeWidth);
            line.setAttribute('stroke-dasharray', 'none');
            svgContainer.appendChild(line);
            var textEl = null;
            if (g.text && (g.text.content || g.text.content === '')) {
              var key = (g.text.content || '') + '|' + (g.text.x || 0) + '|' + (g.text.y || 0);
              if (textCache.has(key)) {
                textEl = textCache.get(key);
              } else {
                textEl = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                textEl.setAttribute('x', g.text.x || 0);
                textEl.setAttribute('y', g.text.y || 0);
                textEl.setAttribute('font-size', TEXT_STYLE.fontSize);
                textEl.setAttribute('fill', TEXT_STYLE.fill);
                textEl.setAttribute('text-anchor', 'start');
                textEl.setAttribute('dominant-baseline', 'middle');
                textEl.textContent = g.text.content || '';

                // 如果SVG有Y轴翻转，对文字应用反向transform修复镜像
                if (hasYFlip) {
                  // 使用 translate 来调整翻转后的位置
                  // scale(1, -1) 会将y坐标翻转，所以需要 translate(0, -2*y) 来补偿
                  var textY = g.text.y || 0;
                  textEl.setAttribute('transform', 'scale(1, -1) translate(0, ' + (-2 * textY) + ')');
                  // 保存翻转标志，用于后续更新位置时调整y坐标
                  textEl._hasYFlip = true;
                }

                svgContainer.appendChild(textEl);
                textCache.set(key, textEl);
              }
            }
            cloudLineMap[cloudId].push({
              lineElement: line,
              textElement: textEl,
              endPoint: {
                x: g.line.x2,
                y: g.line.y2
              },
              layerName: targetLayerName || markupExt.activeLayer || null
            });
            restoreIds[cloudId] = true;

          }
        }
      }

      function restoreAll(data) {
        // var core = markupExt;
        // if (core) {
        //   markupExt = core;
        // }

        try {
          if (data.viewerState && (markupExt.viewer && markupExt.viewer.restoreState)) {
            markupExt.viewer.restoreState(data.viewerState);
          } else if (data.viewerState && viewer && viewer.restoreState) {
            viewer.restoreState(data.viewerState);
          }
        } catch (e) { }
        var restoredLayerName = null;
        try {
          if (data.markupsSvg) {
            var requestedLayer = data.layer || 'Layer1';
            var actualLayer = requestedLayer;
            markupExt.leaveEditMode()
            var ok = markupExt.loadMarkups(data.markupsSvg, actualLayer);

            if (!ok) {
              console.warn('恢复失败');
            } else {
              console.log('恢复成功');
            }
            if (ok && actualLayer) {
              restoredLayerName = actualLayer;
            }
          }
        } catch (e) { }
        try {
          if (data.guides) restoreGuideLines(data.guides, restoredLayerName || data.layer);
        } catch (e) { }
      }



      function onLoadSuccess(event) {

        if (!markupExt) {
          console.error('MarkupsCore 扩展未加载');
          return;
        }


        // 获取事件常量 - 通过扩展实例的构造函数访问
        var MarkupsCore = markupExt.constructor;

        // 获取必要的事件常量
        var EVENT_EDITMODE_CREATION_END = (MarkupsCore && MarkupsCore
          .EVENT_EDITMODE_CREATION_END) || 'EVENT_EDITMODE_CREATION_END';
        var EVENT_EDITMODE_CHANGED = (MarkupsCore && MarkupsCore.EVENT_EDITMODE_CHANGED) ||
          'EVENT_EDITMODE_CHANGED';
        var EVENT_MARKUP_DELETE_EDITION = (MarkupsCore && MarkupsCore
          .EVENT_MARKUP_DELETE_EDITION) || 'EVENT_MARKUP_DELETE_EDITION';

        // 监听批注创建结束事件（合并多种监听方式，只保留最有效的）
        function setupMarkupCreationEndListener() {
          // 方式1: 直接监听 editMode 的事件（最可靠）
          if (markupExt.editMode) {
            markupExt.editMode.addEventListener(EVENT_EDITMODE_CREATION_END, function (
              event) {
              console.log('批注创建结束事件触发1:', event);
              if (!event.creationCancelled) {
                setTimeout(function () {
                  onMarkupCreationEnd(event);
                }, 100);
              }
            });
          }

          var EVENT_MARKUP_DELETE_EDITION = MarkupsCore.EVENT_MARKUP_DELETE_EDITION ||
            'EVENT_MARKUP_DELETE_EDITION';

          // 监听删除事件
          markupExt.addEventListener(EVENT_MARKUP_DELETE_EDITION, function (event) {
            console.log('标记被删除:', event.markup);
            // 在这里处理删除逻辑
          });

          // 方式2: 监听扩展实例的事件（备用）
          markupExt.addEventListener(EVENT_EDITMODE_CREATION_END, function (event) {
            console.log('批注创建结束事件触发2:', event);
            if (!event.creationCancelled) {
              setTimeout(function () {
                onMarkupCreationEnd(event);
              }, 100);
            }
          });

          // 方式3: 监听 editMode 变化事件，当 editMode 改变时重新绑定
          markupExt.addEventListener(EVENT_EDITMODE_CHANGED, function (event) {
            console.log('批注创建结束事件触发3:', event);
            if (event.target && event.target.addEventListener) {
              event.target.addEventListener(EVENT_EDITMODE_CREATION_END, function (
                creationEvent) {
                if (!creationEvent.creationCancelled) {
                  setTimeout(function () {
                    console.log('批注创建结束事件触发244:',
                      creationEvent);
                    onMarkupCreationEnd(creationEvent);
                  }, 100);
                }
              });
            }
          });
        }

        setupMarkupCreationEndListener();

        // 添加云线变换监听（移动、缩放、旋转等）
        setupMarkupTransformListener();

        // 添加模式切换监听
        setupModeSwitch();

        // 添加回车键监听（多对一模式）
        // setupEnterKeyListener();




      }

      onLoadSuccess();
      // 批注创建结束回调函数
      function onMarkupCreationEnd(event) {
        console.log('批注创建结束事件触发:', event);

        if (!markupExt) {
          console.error('markupExt 未定义');
          return;
        }

        // 尝试多种方式获取最新创建的批注
        var lastMarkup = null;

        //从 markups 数组获取最后一个
        if (markupExt.markups && markupExt.markups.length > 0) {
          lastMarkup = markupExt.markups[markupExt.markups.length - 1];
          console.log('从 markups 数组获取的批注:', lastMarkup);
        }

        if (lastMarkup) {
          console.log('找到批注，类型:', lastMarkup.type, '完整对象:', lastMarkup);

          // 检查是否是云线类型（可能是 'cloud' 或其他变体）
          var isCloud = false;
          if (lastMarkup.type === 'cloud' ||
            lastMarkup.type === 'Cloud' ||
            (lastMarkup.constructor && lastMarkup.constructor.name && lastMarkup.constructor.name.indexOf('Cloud') >=
              0)) {
            isCloud = true;
          }

          if (isCloud) {
            console.log('检测到云线批注，当前模式:', drawMode);

            if (drawMode === 'one-to-one') {
              // 一对一模式：立即显示输入弹窗
              currentCloudMarkup = lastMarkup;
              showCloudInputModal();
            } else if (drawMode === 'many-to-one') {
              // 多对一模式：收集云线到数组，等待回车键触发
              cloudMarkups.push(lastMarkup);
              console.log('多对一模式：已收集云线，当前数量:', cloudMarkups.length);
              console.log('提示：按回车键开始绘制');
            }
          } else {
            console.log('批注类型不是云线，类型为:', lastMarkup.type);
          }
        } else {
          console.warn('未找到最新创建的批注');
        }
      }

      // 显示云线输入弹窗
      function showCloudInputModal() {
        var modal = document.getElementById('cloudInputModal');
        var input = document.getElementById('cloudInputText');
        var confirmBtn = document.getElementById('cloudInputConfirm');
        var cancelBtn = document.getElementById('cloudInputCancel');

        modal.classList.add('show');
        input.value = '';
        input.focus();

        // 确定按钮事件
        confirmBtn.onclick = function () {
          var text = input.value.trim();
          if (text) {
            lineText = text;
            _this.form.description = text;
            hideCloudInputModal();

            if (drawMode === 'one-to-one') {
              startDrawingLine();
            } else if (drawMode === 'many-to-one') {
              startMultiDrawingLine();
            }
          } else {
            alert('请输入内容');
          }
        };

        // 取消按钮事件
        cancelBtn.onclick = function () {
          hideCloudInputModal();
          if (drawMode === 'one-to-one') {
            currentCloudMarkup = null;
          } else if (drawMode === 'many-to-one') {
            cloudMarkups = [];
          }
        };

        // 回车键确认
        input.onkeypress = function (e) {
          if (e.key === 'Enter') {
            confirmBtn.onclick();
          }
        };
      }

      // 隐藏云线输入弹窗
      function hideCloudInputModal() {
        var modal = document.getElementById('cloudInputModal');
        modal.classList.remove('show');
      }

      /**
       * 开始一对一绘制模式
       * 从云线边缘向鼠标位置绘制引线
       * 使用配置的样式常量：LINE_STYLE, TEXT_STYLE, TEXT_POSITION
       */
      function startDrawingLine() {
        if (!currentCloudMarkup || !markupExt) {
          return;
        }

        // 获取云线的形状
        var cloudShape = currentCloudMarkup.shape;
        if (!cloudShape) {
          console.error('无法获取云线形状');
          return;
        }

        // 保存云线形状和边界框，用于后续计算
        currentCloudMarkup._cloudShape = cloudShape;
        currentCloudMarkup._cloudBBox = cloudShape.getBBox();

        // 初始起点设为云线中心（后续会根据终点位置动态调整）
        var bbox = currentCloudMarkup._cloudBBox;
        lineStartPoint = {
          x: bbox.x + bbox.width / 2,
          y: bbox.y + bbox.height / 2
        };

        console.log('开始绘制线，云线边界框:', bbox);

        // 获取SVG容器
        var svgContainer = cloudShape.ownerSVGElement || cloudShape.closest('svg');
        if (!svgContainer) {
          // 尝试从扩展获取SVG
          if (markupExt.editModeSvgLayerNode && markupExt.editModeSvgLayerNode.svg) {
            svgContainer = markupExt.editModeSvgLayerNode.svg;
          } else if (markupExt.svgLayersMap && markupExt.activeLayer) {
            var layer = markupExt.svgLayersMap[markupExt.activeLayer];
            if (layer && layer.svg) {
              svgContainer = layer.svg;
            }
          }
        }

        if (!svgContainer) {
          console.error('无法获取SVG容器');
          return;
        }

        // 创建临时线元素
        tempLineElement = document.createElementNS('http://www.w3.org/2000/svg', 'line');
        tempLineElement.setAttribute('x1', lineStartPoint.x);
        tempLineElement.setAttribute('y1', lineStartPoint.y);
        tempLineElement.setAttribute('x2', lineStartPoint.x);
        tempLineElement.setAttribute('y2', lineStartPoint.y);
        tempLineElement.setAttribute('stroke', LINE_STYLE.stroke);
        tempLineElement.setAttribute('stroke-width', LINE_STYLE.strokeWidth);
        tempLineElement.setAttribute('stroke-dasharray', LINE_STYLE.strokeDasharray);
        svgContainer.appendChild(tempLineElement);
        console.log(6666, tempLineElement)

        // 检查SVG容器是否有transform: scale(1, -1)（用于修复文字镜像）
        var svgTransform = '';
        // 检查attribute
        if (svgContainer.getAttribute('transform')) {
          svgTransform = svgContainer.getAttribute('transform');
        }
        // 检查style
        if (!svgTransform && svgContainer.style && svgContainer.style.transform) {
          svgTransform = svgContainer.style.transform;
        }
        // 检查computed style（如果通过CSS设置）
        if (!svgTransform && window.getComputedStyle) {
          var computedStyle = window.getComputedStyle(svgContainer);
          if (computedStyle.transform && computedStyle.transform !== 'none') {
            svgTransform = computedStyle.transform;
          }
        }

        var hasYFlip = svgTransform.includes('scale(1, -1)') ||
          svgTransform.includes('scale(1,-1)') ||
          svgTransform.includes('matrix') && svgTransform.includes('-1');

        // 创建临时文本元素
        tempTextElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        tempTextElement.setAttribute('x', lineStartPoint.x);
        tempTextElement.setAttribute('y', lineStartPoint.y);
        tempTextElement.setAttribute('font-size', TEXT_STYLE.fontSize);
        tempTextElement.setAttribute('fill', TEXT_STYLE.fill);
        tempTextElement.setAttribute('text-anchor', TEXT_STYLE.textAnchor);
        tempTextElement.setAttribute('dominant-baseline', TEXT_STYLE.dominantBaseline);
        tempTextElement.textContent = lineText || _this.form.description;
        // 如果SVG有Y轴翻转，对文字应用反向transform修复镜像
        if (hasYFlip) {
          // 使用 translate 来调整翻转后的位置
          // scale(1, -1) 会将y坐标翻转，所以需要 translate(0, -2*y) 来补偿
          var initialY = lineStartPoint.y;
          tempTextElement.setAttribute('transform', 'scale(1, -1) translate(0, ' + (-2 * initialY) + ')');
          // 保存翻转标志，用于后续更新位置时调整y坐标
          tempTextElement._hasYFlip = true;
        }

        svgContainer.appendChild(tempTextElement);

        isDrawingLine = true;

        // 监听鼠标移动和点击事件
        viewer.container.addEventListener('mousemove', onMouseMoveWhileDrawing, true);
        viewer.container.addEventListener('click', onMouseClickWhileDrawing, true);

        // 监听ESC键取消绘制
        document.addEventListener('keydown', onKeyDownWhileDrawing);
      }

      // 键盘事件处理（ESC取消绘制）
      function onKeyDownWhileDrawing(event) {
        if (event.key === 'Escape' && isDrawingLine) {
          cancelDrawingLine();
        }
      }

      // 取消绘制线
      function cancelDrawingLine() {
        if (!isDrawingLine) {
          return;
        }

        // 移除临时元素
        if (tempLineElement && tempLineElement.parentNode) {
          // tempLineElement.parentNode.removeChild(tempLineElement);
        }
        if (tempTextElement && tempTextElement.parentNode) {
          // tempTextElement.parentNode.removeChild(tempTextElement);
        }

        // 移除事件监听
        viewer.container.removeEventListener('mousemove', onMouseMoveWhileDrawing, true);
        viewer.container.removeEventListener('click', onMouseClickWhileDrawing, true);
        document.removeEventListener('keydown', onKeyDownWhileDrawing);

        // 重置状态
        isDrawingLine = false;
        currentCloudMarkup = null;
        lineText = null;
        tempLineElement = null;
        tempTextElement = null;

        console.log('线绘制已取消');
      }

      /**
       * 计算云线边缘上距离终点最近的点
       * @param {Object} endPoint - 终点坐标 {x, y}
       * @param {Object} cloudBBox - 云线边界框 {x, y, width, height}
       * @returns {Object} 云线边缘上的点 {x, y}
       */
      function getClosestPointOnCloudEdge(endPoint, cloudBBox) {
        if (!cloudBBox) {
          return null;
        }

        var cx = cloudBBox.x + cloudBBox.width / 2;
        var cy = cloudBBox.y + cloudBBox.height / 2;
        var ex = endPoint.x;
        var ey = endPoint.y;

        // 计算从云线中心到终点的方向
        var dx = ex - cx;
        var dy = ey - cy;
        var distance = Math.sqrt(dx * dx + dy * dy);

        if (distance === 0) {
          // 如果终点就在中心，返回边缘上的一个点
          return {
            x: cloudBBox.x + cloudBBox.width,
            y: cy
          };
        }

        // 归一化方向向量
        var nx = dx / distance;
        var ny = dy / distance;

        // 计算云线边界框的半宽和半高
        var halfWidth = cloudBBox.width / 2;
        var halfHeight = cloudBBox.height / 2;

        // 使用更精确的方法计算边缘点
        // 考虑边界框是一个矩形，找到从中心沿方向向量到矩形边缘的交点
        var edgePoint = null;

        // 计算与边界框四条边的交点，选择最近的一个
        var intersections = [];

        // 与上边（y = bbox.y）的交点
        if (ny < 0) {
          var t = (cloudBBox.y - cy) / ny;
          var x = cx + nx * t;
          if (x >= cloudBBox.x && x <= cloudBBox.x + cloudBBox.width) {
            intersections.push({
              x: x,
              y: cloudBBox.y,
              t: t
            });
          }
        }

        // 与下边（y = bbox.y + bbox.height）的交点
        if (ny > 0) {
          var t = (cloudBBox.y + cloudBBox.height - cy) / ny;
          var x = cx + nx * t;
          if (x >= cloudBBox.x && x <= cloudBBox.x + cloudBBox.width) {
            intersections.push({
              x: x,
              y: cloudBBox.y + cloudBBox.height,
              t: t
            });
          }
        }

        // 与左边（x = bbox.x）的交点
        if (nx < 0) {
          var t = (cloudBBox.x - cx) / nx;
          var y = cy + ny * t;
          if (y >= cloudBBox.y && y <= cloudBBox.y + cloudBBox.height) {
            intersections.push({
              x: cloudBBox.x,
              y: y,
              t: t
            });
          }
        }

        // 与右边（x = bbox.x + bbox.width）的交点
        if (nx > 0) {
          var t = (cloudBBox.x + cloudBBox.width - cx) / nx;
          var y = cy + ny * t;
          if (y >= cloudBBox.y && y <= cloudBBox.y + cloudBBox.height) {
            intersections.push({
              x: cloudBBox.x + cloudBBox.width,
              y: y,
              t: t
            });
          }
        }

        // 选择距离中心最近（t值最小且为正）的交点
        if (intersections.length > 0) {
          intersections.sort(function (a, b) {
            return a.t - b.t;
          });
          edgePoint = {
            x: intersections[0].x,
            y: intersections[0].y
          };
        } else {
          // 如果没有找到交点，使用简单方法
          var edgeDistance = 0;
          if (Math.abs(nx) > Math.abs(ny)) {
            edgeDistance = halfWidth / Math.abs(nx);
          } else {
            edgeDistance = halfHeight / Math.abs(ny);
          }
          edgePoint = {
            x: cx + nx * edgeDistance,
            y: cy + ny * edgeDistance
          };
        }

        return edgePoint;
      }

      // 鼠标移动时更新线的终点和起点
      function onMouseMoveWhileDrawing(event) {
        if (!isDrawingLine || !tempLineElement) {
          return;
        }

        // 获取鼠标在SVG中的坐标
        var svgContainer = tempLineElement.ownerSVGElement;
        if (!svgContainer) {
          return;
        }
        var endPoint = getMousePositionInSvg(event, svgContainer);
        if (endPoint && currentCloudMarkup && currentCloudMarkup._cloudBBox) {
          // 根据终点位置计算云线边缘上的最近点作为起点
          lineStartPoint = getClosestPointOnCloudEdge(endPoint, currentCloudMarkup._cloudBBox);

          // 更新线的起点和终点
          tempLineElement.setAttribute('x1', lineStartPoint.x);
          tempLineElement.setAttribute('y1', lineStartPoint.y);
          tempLineElement.setAttribute('x2', endPoint.x);
          tempLineElement.setAttribute('y2', endPoint.y);

          // 计算线的角度，用于调整文字方向
          var dx = endPoint.x - lineStartPoint.x;
          var dy = endPoint.y - lineStartPoint.y;
          var angle = Math.atan2(dy, dx) * 180 / Math.PI;

          // 更新文本位置和方向
          if (tempTextElement) {
            // 计算文本偏移量，使文字在线的右侧（从起点看向终点）
            // 线的方向向量已经归一化，计算垂直向量
            var perpX = -dy / Math.sqrt(dx * dx + dy * dy);
            var perpY = dx / Math.sqrt(dx * dx + dy * dy);

            // 如果线的长度太小，使用默认偏移
            var lineLength = Math.sqrt(dx * dx + dy * dy);
            if (lineLength < 1) {
              perpX = 1;
              perpY = 0;
            }

            // 文本偏移距离
            var textOffset = TEXT_POSITION.offset;

            // 计算文本位置（在终点附近，垂直于线的方向）
            var textX = endPoint.x + perpX * textOffset;
            var textY = endPoint.y + perpY * textOffset;

            tempTextElement.setAttribute('x', textX);
            tempTextElement.setAttribute('y', textY);

            // 如果文字有Y轴翻转，更新transform以正确显示位置
            if (tempTextElement._hasYFlip) {
              // 使用 translate 来调整翻转后的位置
              // scale(1, -1) 会将y坐标翻转，所以需要 translate(0, -2*y) 来补偿
              tempTextElement.setAttribute('transform', 'scale(1, -1) translate(0, ' + (-2 * textY) + ')');
            }

            // 设置文本锚点为开始（左对齐），这样文字会从指定位置开始向右显示
            tempTextElement.setAttribute('text-anchor', 'start');
            tempTextElement.setAttribute('dominant-baseline', 'middle');
          }
        }
      }

      // 鼠标点击时确定终点位置
      function onMouseClickWhileDrawing(event) {
        if (!isDrawingLine || !tempLineElement) {
          return;
        }

        // 阻止事件冒泡，避免触发viewer的其他操作
        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();

        // 获取鼠标在SVG中的坐标
        var svgContainer = tempLineElement.ownerSVGElement;
        if (!svgContainer) {
          return;
        }

        var endPoint = getMousePositionInSvg(event, svgContainer);
        if (endPoint && currentCloudMarkup && currentCloudMarkup._cloudBBox) {
          // 根据终点位置计算云线边缘上的最近点作为起点
          lineStartPoint = getClosestPointOnCloudEdge(endPoint, currentCloudMarkup._cloudBBox);
          lineEndPoint = endPoint;

          // 更新线的起点和终点位置
          tempLineElement.setAttribute('x1', lineStartPoint.x);
          tempLineElement.setAttribute('y1', lineStartPoint.y);
          tempLineElement.setAttribute('x2', endPoint.x);
          tempLineElement.setAttribute('y2', endPoint.y);

          // 计算线的方向，更新文本位置
          var dx = endPoint.x - lineStartPoint.x;
          var dy = endPoint.y - lineStartPoint.y;

          if (tempTextElement) {
            // 计算文本偏移量，使文字在线的右侧（从起点看向终点）
            var perpX = -dy / Math.sqrt(dx * dx + dy * dy);
            var perpY = dx / Math.sqrt(dx * dx + dy * dy);

            // 如果线的长度太小，使用默认偏移
            var lineLength = Math.sqrt(dx * dx + dy * dy);
            if (lineLength < 1) {
              perpX = 1;
              perpY = 0;
            }

            // 文本偏移距离
            var textOffset = TEXT_POSITION.offset;

            // 计算文本位置（在终点附近，垂直于线的方向）
            var textX = endPoint.x + perpX * textOffset;
            var textY = endPoint.y + perpY * textOffset;

            tempTextElement.setAttribute('x', textX);
            tempTextElement.setAttribute('y', textY);

            // 如果文字有Y轴翻转，更新transform以正确显示位置
            if (tempTextElement._hasYFlip) {
              // 使用 translate 来调整翻转后的位置
              // scale(1, -1) 会将y坐标翻转，所以需要 translate(0, -2*y) 来补偿
              tempTextElement.setAttribute('transform', 'scale(1, -1) translate(0, ' + (-2 * textY) + ')');
            }

            tempTextElement.setAttribute('text-anchor', 'start');
            tempTextElement.setAttribute('dominant-baseline', 'middle');
          }

          // 确定终点，完成绘制
          finishDrawingLine();
        }
      }

      /**
       * 获取鼠标在SVG坐标系中的坐标
       * 使用 Forge Viewer 的 clientToMarkups 方法进行坐标转换
       * @param {MouseEvent} event - 鼠标事件
       * @param {SVGElement} svgElement - SVG元素（未使用，保留以兼容）
       * @returns {Object} 坐标对象 {x, y} 或 null
       */
      function getMousePositionInSvg(event, svgElement) {
        if (!markupExt || !viewer) {
          return null;
        }

        // 使用 Forge Viewer 的 clientToMarkups 方法进行坐标转换
        var clientX = event.clientX;
        var clientY = event.clientY;

        // 获取viewer容器的边界
        var containerRect = viewer.container.getBoundingClientRect();
        var relativeX = clientX - containerRect.left;
        var relativeY = clientY - containerRect.top;

        // 使用扩展的 clientToMarkups 方法
        var point = markupExt.clientToMarkups(relativeX, relativeY);

        return {
          x: point.x,
          y: point.y
        };
      }

      // 完成绘制线
      function finishDrawingLine() {
        if (!isDrawingLine) {
          return;
        }

        // 将虚线改为实线，完成绘制
        if (tempLineElement && tempLineElement.parentNode) {
          tempLineElement.setAttribute('stroke-dasharray', 'none');

          // 保存云线和直线的关联关系
          if (currentCloudMarkup && currentCloudMarkup.id !== undefined) {
            var cloudId = currentCloudMarkup.id;
            if (!cloudLineMap[cloudId]) {
              cloudLineMap[cloudId] = [];
            }
            cloudLineMap[cloudId].push({
              lineElement: tempLineElement,
              textElement: tempTextElement,
              endPoint: {
                x: lineEndPoint.x,
                y: lineEndPoint.y
              }, // 保存终点坐标
              layerName: getDefaultLayerName()
            });
          }
        }

        // 移除事件监听
        viewer.container.removeEventListener('mousemove', onMouseMoveWhileDrawing, true);
        viewer.container.removeEventListener('click', onMouseClickWhileDrawing, true);
        document.removeEventListener('keydown', onKeyDownWhileDrawing);

        // 重置状态
        isDrawingLine = false;
        currentCloudMarkup = null;
        lineText = null;
        tempLineElement = null;
        tempTextElement = null;

        console.log('线绘制完成，起点:', lineStartPoint, '终点:', lineEndPoint, '文本:', lineText);
      }

      /**
       * 更新云线关联的所有直线起点
       * 当云线移动、缩放或旋转时调用
       * @param {Object} cloudMarkup - 云线批注对象
       */
      function updateLineStartPoints(cloudMarkup) {
        if (!cloudMarkup || !cloudMarkup.id) {
          return;
        }

        var cloudId = cloudMarkup.id;
        var lineList = cloudLineMap[cloudId];

        if (!lineList || lineList.length === 0) {
          return;
        }

        // 获取云线的当前边界框
        var cloudBBox = null;
        if (cloudMarkup.shape) {
          cloudBBox = cloudMarkup.shape.getBBox();
          // 更新缓存的边界框
          cloudMarkup._cloudBBox = cloudBBox;
        } else if (cloudMarkup._cloudBBox) {
          cloudBBox = cloudMarkup._cloudBBox;
        }

        if (!cloudBBox) {
          console.warn('无法获取云线边界框');
          return;
        }

        // 更新每条直线的起点
        for (var i = 0; i < lineList.length; i++) {
          var lineData = lineList[i];
          var lineElement = lineData.lineElement;
          var endPoint = lineData.endPoint;

          if (!lineElement) {
            lineList.splice(i, 1);
            i--;
            continue;
          }

          if (!lineElement.parentNode || (lineData.textElement && !lineData.textElement.parentNode)) {
            var attached = ensureGuideElementsAttached(lineData);
            if (!attached) {
              if (lineData._detachTime && (Date.now() - lineData._detachTime) > GUIDE_ORPHAN_REMOVE_DELAY) {
                lineList.splice(i, 1);
                i--;
              }
              continue;
            }
          }

          if (!endPoint) {
            continue;
          }

          // 计算新的起点（云线边缘上距离终点最近的点）
          var newStartPoint = getClosestPointOnCloudEdge(endPoint, cloudBBox);

          if (newStartPoint) {
            // 更新直线起点
            lineElement.setAttribute('x1', newStartPoint.x);
            lineElement.setAttribute('y1', newStartPoint.y);
          }
        }
      }

      /**
       * 设置云线变换事件监听
       * 监听云线的移动、缩放、旋转等变换操作
       */
      function setupMarkupTransformListener() {
        if (!markupExt) {
          return;
        }

        // 监听批注更新事件（包括移动、缩放、旋转等）
        // 使用定时器定期检查云线位置变化（因为 Forge Viewer 可能没有直接的变换事件）
        var lastMarkupPositions = {};

        function checkMarkupTransform() {
          if (!markupExt || !markupExt.markups) {
            return;
          }

          // 收集当前存在的云线ID
          var existingCloudIds = {};

          // 检查所有云线批注
          for (var i = 0; i < markupExt.markups.length; i++) {
            var markup = markupExt.markups[i];

            // 只处理云线类型
            if (markup.type !== 'cloud' && markup.type !== 'cloudrect') {
              continue;
            }

            var markupId = markup.id;
            if (!markupId) {
              continue;
            }

            // 记录存在的云线ID
            existingCloudIds[markupId] = true;

            // 获取当前边界框
            var currentBBox = null;
            if (markup.shape) {
              currentBBox = markup.shape.getBBox();
            }

            if (!currentBBox) {
              continue;
            }

            // 检查位置是否变化
            var lastPos = lastMarkupPositions[markupId];
            var hasChanged = false;

            if (!lastPos) {
              // 首次记录
              hasChanged = true;
            } else {
              // 检查位置或大小是否变化
              var threshold = 0.1; // 允许的误差范围
              if (Math.abs(currentBBox.x - lastPos.x) > threshold ||
                Math.abs(currentBBox.y - lastPos.y) > threshold ||
                Math.abs(currentBBox.width - lastPos.width) > threshold ||
                Math.abs(currentBBox.height - lastPos.height) > threshold) {
                hasChanged = true;
              }
            }

            if (hasChanged) {
              // 更新直线起点
              updateLineStartPoints(markup);

              // 保存当前位置
              lastMarkupPositions[markupId] = {
                x: currentBBox.x,
                y: currentBBox.y,
                width: currentBBox.width,
                height: currentBBox.height
              };
            }
          }
          // 清理已删除的云线的关联关系和位置记录
          for (var cloudId in cloudLineMap) {
            if (!existingCloudIds[cloudId] && !restoreIds[cloudId]) {
              var list = cloudLineMap[cloudId];
              if (list && list.length) {
                // 先删除该云线对应的所有指引线
                for (var k = 0; k < list.length; k++) {
                  var item = list[k];
                  if (item && item.lineElement && item.lineElement.parentNode) {
                    item.lineElement.parentNode.removeChild(item.lineElement);
                  }
                }
                // 再判断文字元素是否仍被其他云线引用，若不再引用则删除
                var candidateTextSet = new Set();
                for (var k2 = 0; k2 < list.length; k2++) {
                  if (list[k2] && list[k2].textElement) {
                    candidateTextSet.add(list[k2].textElement);
                  }
                }
                if (candidateTextSet.size > 0) {
                  // 检查剩余云线是否仍引用这些文字
                  for (var otherId in cloudLineMap) {
                    if (otherId === cloudId) continue;
                    if (!existingCloudIds[otherId]) continue; // 其他同样被删除的无需考虑
                    var otherList = cloudLineMap[otherId];
                    if (!otherList || !otherList.length) continue;
                    for (var m = 0; m < otherList.length; m++) {
                      var oi = otherList[m];
                      if (oi && oi.textElement && candidateTextSet.has(oi.textElement)) {
                        // 被其他云线引用，不能删除
                        candidateTextSet.delete(oi.textElement);
                      }
                      if (candidateTextSet.size === 0) break;
                    }
                    if (candidateTextSet.size === 0) break;
                  }
                  // 删除仍在候选集中（未被其他云线引用）的文字元素
                  candidateTextSet.forEach(function (te) {
                    if (te && te.parentNode) {
                      te.parentNode.removeChild(te);
                    }
                  });
                }
              }
              delete cloudLineMap[cloudId];
              delete lastMarkupPositions[cloudId];
            }
          }
        }

        // 每100ms检查一次（可以根据需要调整频率）
        setInterval(checkMarkupTransform, 200);

        // 也可以监听批注选择事件，当批注被选中时立即检查
        var MarkupsCore = markupExt.constructor;
        var EVENT_MARKUP_SELECTED = (MarkupsCore && MarkupsCore.EVENT_MARKUP_SELECTED) || 'EVENT_MARKUP_SELECTED';

        markupExt.addEventListener(EVENT_MARKUP_SELECTED, function (event) {
          if (event.markup && (event.markup.type === 'cloud' || event.markup.type === 'cloudrect')) {
            // 延迟一点确保变换已完成
            setTimeout(function () {
              updateLineStartPoints(event.markup);
            }, 50);
          }
        });
      }

      // 设置模式切换监听
      function setupModeSwitch() {
        var modeOneToOne = document.getElementById('modeOneToOne');
        var modeManyToOne = document.getElementById('modeManyToOne');

        if (modeOneToOne && modeManyToOne) {
          modeOneToOne.addEventListener('change', function () {
            if (this.checked) {
              drawMode = 'one-to-one';
              console.log('切换到一对一模式');
              // 清空多对一模式的云线数组
              cloudMarkups = [];
            }
          });

          modeManyToOne.addEventListener('change', function () {
            if (this.checked) {
              drawMode = 'many-to-one';
              console.log('切换到多对一模式');
              // 清空多对一模式的云线数组
              cloudMarkups = [];
            }
          });
        }
      }

      // 设置回车键监听（多对一模式）
      function setupEnterKeyListener() {
        document.addEventListener('keydown', function (event) {
          // 只在多对一模式下，且有云线收集时，响应回车键
          if (event.key === 'Enter' && drawMode === 'many-to-one' && cloudMarkups.length > 0 && !
            isMultiDrawing) {
            // 检查是否在输入框中，如果是则不处理（让输入框自己处理回车）
            var activeElement = document.activeElement;
            var modal = document.getElementById('cloudInputModal');
            var isModalVisible = modal && modal.classList.contains('show');

            // 如果输入框可见且焦点在输入框内，不处理
            if (isModalVisible && activeElement && (activeElement.tagName === 'INPUT' || activeElement
              .tagName === 'TEXTAREA')) {
              return;
            }

            event.preventDefault();
            event.stopPropagation();
            console.log('多对一模式：回车键触发，开始绘制，云线数量:', cloudMarkups.length);
            showCloudInputModal();
          }
        }, true); // 使用捕获阶段，确保能捕获到事件
      }

      /**
       * 开始多对一绘制模式
       * 多个云线同时向鼠标位置绘制引线，共享一个文字标签
       * 使用配置的样式常量：LINE_STYLE, TEXT_STYLE, TEXT_POSITION
       */
      function startMultiDrawingLine() {
        if (cloudMarkups.length === 0 || !markupExt) {
          console.error('没有云线或扩展未加载');
          _this.isFinishMultiDrawing = true;
          return;
        }

        isMultiDrawing = true;
        multiLineElements = [];
        multiTextElements = [];

        // 获取SVG容器（使用第一个云线的容器）
        var firstCloud = cloudMarkups[0];
        var cloudShape = firstCloud.shape;
        if (!cloudShape) {
          console.error('无法获取云线形状');
          return;
        }

        var svgContainer = cloudShape.ownerSVGElement || cloudShape.closest('svg');
        if (!svgContainer) {
          if (markupExt.editModeSvgLayerNode && markupExt.editModeSvgLayerNode.svg) {
            svgContainer = markupExt.editModeSvgLayerNode.svg;
          } else if (markupExt.svgLayersMap && markupExt.activeLayer) {
            var layer = markupExt.svgLayersMap[markupExt.activeLayer];
            if (layer && layer.svg) {
              svgContainer = layer.svg;
            }
          }
        }

        if (!svgContainer) {
          console.error('无法获取SVG容器');
          return;
        }

        // 检查SVG是否有Y轴翻转
        var svgTransform = '';
        if (svgContainer.getAttribute('transform')) {
          svgTransform = svgContainer.getAttribute('transform');
        }
        if (!svgTransform && svgContainer.style && svgContainer.style.transform) {
          svgTransform = svgContainer.style.transform;
        }
        if (!svgTransform && window.getComputedStyle) {
          var computedStyle = window.getComputedStyle(svgContainer);
          if (computedStyle.transform && computedStyle.transform !== 'none') {
            svgTransform = computedStyle.transform;
          }
        }
        var hasYFlip = svgTransform.includes('scale(1, -1)') ||
          svgTransform.includes('scale(1,-1)') ||
          svgTransform.includes('matrix') && svgTransform.includes('-1');

        // 为每个云线创建线元素
        for (var i = 0; i < cloudMarkups.length; i++) {
          var cloudMarkup = cloudMarkups[i];
          var cloudShape = cloudMarkup.shape;
          if (!cloudShape) continue;

          // 保存云线边界框，用于后续计算起点
          var bbox = cloudShape.getBBox();
          cloudMarkup._cloudBBox = bbox;
          cloudMarkup._cloudShape = cloudShape;

          var startPoint = {
            x: bbox.x + bbox.width / 2,
            y: bbox.y + bbox.height / 2
          };

          // 创建线元素
          var lineElement = document.createElementNS('http://www.w3.org/2000/svg', 'line');
          lineElement.setAttribute('x1', startPoint.x);
          lineElement.setAttribute('y1', startPoint.y);
          lineElement.setAttribute('x2', startPoint.x);
          lineElement.setAttribute('y2', startPoint.y);
          lineElement.setAttribute('stroke', LINE_STYLE.stroke);
          lineElement.setAttribute('stroke-width', LINE_STYLE.strokeWidth);
          lineElement.setAttribute('stroke-dasharray', LINE_STYLE.strokeDasharray);
          svgContainer.appendChild(lineElement);
          multiLineElements.push({
            element: lineElement,
            startPoint: startPoint,
            cloudMarkup: cloudMarkup
          });
        }

        // 只创建一个文本元素（共享文字）
        var firstStartPoint = multiLineElements.length > 0 ? multiLineElements[0].startPoint : {
          x: 0,
          y: 0
        };
        var textElement = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        textElement.setAttribute('x', firstStartPoint.x);
        textElement.setAttribute('y', firstStartPoint.y);
        textElement.setAttribute('font-size', TEXT_STYLE.fontSize);
        textElement.setAttribute('fill', TEXT_STYLE.fill);
        textElement.setAttribute('text-anchor', TEXT_STYLE.textAnchor);
        textElement.setAttribute('dominant-baseline', TEXT_STYLE.dominantBaseline);
        textElement.textContent = lineText || _this.form.description;

        if (hasYFlip) {
          var initialY = firstStartPoint.y;
          textElement.setAttribute('transform', 'scale(1, -1) translate(0, ' + (-2 * initialY) + ')');
          textElement._hasYFlip = true;
        }

        svgContainer.appendChild(textElement);
        multiTextElements.push(textElement); // 只保存一个文字元素

        // 监听鼠标移动和点击事件
        viewer.container.addEventListener('mousemove', onMouseMoveWhileMultiDrawing, true);
        viewer.container.addEventListener('click', onMouseClickWhileMultiDrawing, true);
        document.addEventListener('keydown', onKeyDownWhileMultiDrawing);
      }

      // 多对一模式：鼠标移动时更新所有线的终点
      function onMouseMoveWhileMultiDrawing(event) {
        if (!isMultiDrawing || multiLineElements.length === 0) {
          return;
        }

        var svgContainer = multiLineElements[0].element.ownerSVGElement;
        if (!svgContainer) {
          return;
        }

        var endPoint = getMousePositionInSvg(event, svgContainer);
        if (endPoint) {
          // 更新所有线的终点
          for (var i = 0; i < multiLineElements.length; i++) {
            var lineData = multiLineElements[i];
            var cloudBBox = lineData.cloudMarkup._cloudBBox || lineData.cloudMarkup.shape.getBBox();

            // 计算云线边缘上的起点
            var startPoint = getClosestPointOnCloudEdge(endPoint, cloudBBox);

            lineData.element.setAttribute('x1', startPoint.x);
            lineData.element.setAttribute('y1', startPoint.y);
            lineData.element.setAttribute('x2', endPoint.x);
            lineData.element.setAttribute('y2', endPoint.y);
          }

          // 只更新一个文字元素的位置（在终点附近）
          if (multiTextElements.length > 0 && multiTextElements[0]) {
            var textElement = multiTextElements[0];
            var textX = endPoint.x + TEXT_POSITION.offsetX;
            var textY = endPoint.y + TEXT_POSITION.offsetY; // 在终点上方

            textElement.setAttribute('x', textX);
            textElement.setAttribute('y', textY);

            if (textElement._hasYFlip) {
              textElement.setAttribute('transform', 'scale(1, -1) translate(0, ' + (-2 * textY) + ')');
            }
          }
        }
      }

      // 多对一模式：鼠标点击时确定终点位置
      function onMouseClickWhileMultiDrawing(event) {
        if (!isMultiDrawing || multiLineElements.length === 0) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();
        event.stopImmediatePropagation();

        var svgContainer = multiLineElements[0].element.ownerSVGElement;
        if (!svgContainer) {
          return;
        }

        var endPoint = getMousePositionInSvg(event, svgContainer);
        if (endPoint) {
          // 更新所有线的终点
          for (var i = 0; i < multiLineElements.length; i++) {
            var lineData = multiLineElements[i];
            var cloudBBox = lineData.cloudMarkup._cloudBBox || lineData.cloudMarkup.shape.getBBox();

            // 计算云线边缘上的起点
            var startPoint = getClosestPointOnCloudEdge(endPoint, cloudBBox);

            lineData.element.setAttribute('x1', startPoint.x);
            lineData.element.setAttribute('y1', startPoint.y);
            lineData.element.setAttribute('x2', endPoint.x);
            lineData.element.setAttribute('y2', endPoint.y);

            // 将虚线改为实线
            lineData.element.setAttribute('stroke-dasharray', 'none');

            // 保存云线和直线的关联关系
            var cloudId = lineData.cloudMarkup.id;
            if (cloudId !== undefined) {
              if (!cloudLineMap[cloudId]) {
                cloudLineMap[cloudId] = [];
              }
              // 查找是否已存在（避免重复添加）
              var exists = false;
              for (var j = 0; j < cloudLineMap[cloudId].length; j++) {
                if (cloudLineMap[cloudId][j].lineElement === lineData.element) {
                  exists = true;
                  // 更新终点
                  cloudLineMap[cloudId][j].endPoint = {
                    x: endPoint.x,
                    y: endPoint.y
                  };
                  break;
                }
              }
              if (!exists) {
                cloudLineMap[cloudId].push({
                  lineElement: lineData.element,
                  textElement: multiTextElements.length > 0 ? multiTextElements[0] : null,
                  endPoint: {
                    x: endPoint.x,
                    y: endPoint.y
                  },
                  layerName: getDefaultLayerName()
                });
              }
            }
          }

          // 只更新一个文字元素的位置（在终点附近）
          if (multiTextElements.length > 0 && multiTextElements[0]) {
            var textElement = multiTextElements[0];
            var textX = endPoint.x + TEXT_POSITION.offsetX;
            var textY = endPoint.y + TEXT_POSITION.offsetY; // 在终点上方

            textElement.setAttribute('x', textX);
            textElement.setAttribute('y', textY);

            if (textElement._hasYFlip) {
              textElement.setAttribute('transform', 'scale(1, -1) translate(0, ' + (-2 * textY) + ')');
            }
          }

          // 完成绘制
          finishMultiDrawing();
        }
      }

      // 多对一模式：键盘事件处理（ESC取消绘制）
      function onKeyDownWhileMultiDrawing(event) {
        if (event.key === 'Escape' && isMultiDrawing) {
          cancelMultiDrawing();
        }
      }

      // 取消多对一绘制
      function cancelMultiDrawing() {
        if (!isMultiDrawing) {
          return;
        }

        // 移除所有临时元素
        for (var i = 0; i < multiLineElements.length; i++) {
          if (multiLineElements[i].element && multiLineElements[i].element.parentNode) {
            // multiLineElements[i].element.parentNode.removeChild(multiLineElements[i].element);
          }
        }
        for (var i = 0; i < multiTextElements.length; i++) {
          if (multiTextElements[i] && multiTextElements[i].parentNode) {
            // multiTextElements[i].parentNode.removeChild(multiTextElements[i]);
          }
        }

        // 移除事件监听
        viewer.container.removeEventListener('mousemove', onMouseMoveWhileMultiDrawing, true);
        viewer.container.removeEventListener('click', onMouseClickWhileMultiDrawing, true);
        document.removeEventListener('keydown', onKeyDownWhileMultiDrawing);

        // 重置状态
        isMultiDrawing = false;
        cloudMarkups = [];
        multiLineElements = [];
        multiTextElements = [];

        console.log('多对一绘制已取消');
      }

      // 完成多对一绘制
      function finishMultiDrawing() {
        if (!isMultiDrawing) {
          return;
        }

        _this.isFinishMultiDrawing = true;
        // 移除事件监听
        viewer.container.removeEventListener('mousemove', onMouseMoveWhileMultiDrawing, true);
        viewer.container.removeEventListener('click', onMouseClickWhileMultiDrawing, true);
        document.removeEventListener('keydown', onKeyDownWhileMultiDrawing);

        // 重置状态
        isMultiDrawing = false;
        cloudMarkups = [];
        multiLineElements = [];
        multiTextElements = [];

        console.log('多对一绘制完成');
      }

      function exportAnnotations() {
        if (!markupExt || !viewer) return;
        var markupsPersist = '';
        try {
          markupsPersist = (markupExt.generateData && markupExt.generateData()) ? markupExt.generateData().replace(
            /\"/g, "'") : '';
        } catch (e) {
          markupsPersist = '';
        }
        var viewerStatePersist = {};
        try {
          viewerStatePersist = markupExt.viewer && markupExt.viewer.getState ? markupExt.viewer.getState() : (viewer
            .getState ? viewer.getState() : {});
        } catch (e) {
          viewerStatePersist = {};
        }
        var layerName = markupExt && markupExt.activeLayer ? markupExt.activeLayer : 'Layer1';
        var payload = {
          viewerState: viewerStatePersist,
          markupsSvg: markupsPersist,
          layer: layerName,
          guides: getGuideLinesData()
        };
        var json = JSON.stringify(payload, null, 2);
        return json;
      }
      // 将方法暴露到 window
      window.getAllCloudMarkups = getAllCloudMarkups;
      window.getGuideLinesData = getGuideLinesData;
      window.exportAnnotations = exportAnnotations;
      window.importAnnotationsFromJSON = importAnnotationsFromJSON;
      window.startMultiDrawingLine = startMultiDrawingLine;
      window.captureScreenshot = captureScreenshot;

      function getMarkupsLayerSvg() {
        var layerNode = document.querySelector('[layer-order-id="markups-svg"]');
        if (!layerNode) return null;
        if (layerNode.tagName && layerNode.tagName.toLowerCase() === 'svg') {
          return layerNode;
        }
        var childSvg = layerNode.querySelector('svg');
        return childSvg || null;
      }

      function svgElementToDataUrl(svgElement, width, height) {
        if (!svgElement) return null;
        var cloned = svgElement.cloneNode(true);
        cloned.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        if (width) cloned.setAttribute('width', width);
        if (height) cloned.setAttribute('height', height);
        if (!cloned.getAttribute('viewBox') && width && height) {
          cloned.setAttribute('viewBox', '0 0 ' + width + ' ' + height);
        }
        var serializer = new XMLSerializer();
        var svgString = serializer.serializeToString(cloned);
        var encodedData = window.btoa(unescape(encodeURIComponent(svgString)));
        return 'data:image/svg+xml;base64,' + encodedData;
      }

      function captureScreenshot() {

        var width = _this.viewer.container.clientWidth;
        var height = _this.viewer.container.clientHeight;

        function dataURLtoBlob(dataurl) {
          var arr = dataurl.split(',');
          var mime = arr[0].match(/:(.*?);/)[1];
          var bstr = atob(arr[1]);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return new Blob([u8arr], { type: mime });
        }

        function blobToFile(blob, fileName) {
          blob.lastModifiedDate = new Date();
          blob.name = fileName;
          return blob;
        }

        function dataURLtoFile(dataurl, filename) {
          var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blob = dataURLtoBlob(dataurl);
          return blobToFile(blob, filename);
        }

        function canvasToBase64Sync() {
          const canvas = document.getElementById("snapshot");
          if (!canvas) {
            throw new Error('找不到canvas元素');
          }

          return canvas.toDataURL("image/png");
        }


        function downloadCanvas() {
          // var file = dataURLtoFile(document.getElementById("snapshot").toDataURL(), "viewpoint.png");
          // var url = URL.createObjectURL(file);
          // var link = document.createElement('a');
          // link.href = url;
          // link.download = file.name || 'viewpoint.png';
          // document.body.appendChild(link);
          // link.click();
          // document.body.removeChild(link);
          // URL.revokeObjectURL(url);

          var filedata = {
            name:
              new Date().toLocaleDateString() +
              "_" +
              new Date().toLocaleTimeString() +
              "截图",
            url: canvasToBase64Sync(),
            view: _this.viewer ? JSON.stringify(_this.viewer.getState()) : null,
            f2d: _this.model2dpath,
            type: 1
          };
          var markupd = window.exportAnnotations();
          if (markupd)
            filedata.markup = markupd;
          _this.form.files.push(filedata);
        }

        _this.viewer.getScreenShot(width, height, function (blobURL) {
          var baseImage = new Image();
          baseImage.onload = function () {
            var canvas = document.getElementById('snapshot');
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, width, height);
            ctx.drawImage(baseImage, 0, 0, width, height);

            var markupsSvg = getMarkupsLayerSvg();
            var overlayUrl = markupsSvg ? svgElementToDataUrl(markupsSvg, width, height) : null;

            if (overlayUrl) {
              var overlayImage = new Image();
              overlayImage.onload = function () {
                ctx.drawImage(overlayImage, 0, 0, width, height);
                downloadCanvas();
              };
              overlayImage.onerror = function () {
                downloadCanvas();
              };
              overlayImage.src = overlayUrl;
            } else {
              downloadCanvas();
            }
          };
          baseImage.src = blobURL;
        });

      }

    },
    //2d图纸切换
    change2d() {
      try {
        bimViewPointNew.toolPanel.setVisible(false);
        bimViewPointNew.count = 0;
      } catch (error) { }
      document.getElementById("MyViewerDiv").innerHTML = "";
      this.viewer.tearDown();
      this.viewer = null;
      this.url = this.$store.state.baseUrl + this.model2dpath;
      this.viewers(this.url);

    },
    //初始化forge功能按钮
    viewerFunctions() {
      var _this = this;

      _this.viewer.registerContextMenuCallback(
        "查找全部实例",
        (menu, status) => {
          if (status.hasSelected) {
            menu.push({
              title: "查找全部实例",
              target: () => {
                let ids = [];
                var sel = NOP_VIEWER.getSelection();
                sel.forEach((v) => {
                  var a = _this.viewer.model
                    .getData()
                    .instanceTree.getNodeName(v)
                    .split("[")[0]
                    .trim();
                  _this.viewer.model.search(
                    a,
                    function (data) {
                      ids = ids.concat(data);
                      _this.viewer.select(ids);
                    },
                    null,
                    null,
                    true
                  );
                });
              },
            });
          }
        }
      );

      _this.viewer.registerContextMenuCallback("分享构件", (menu, status) => {
        if (status.hasSelected && status.numSelected < 11) {
          menu.push({
            title: "分享构件",
            target: () => {
              var sel = NOP_VIEWER.getSelection();
              var code = `modelId=${_this.OneUploadFileData.model.mode01
                }^@^dbid=${JSON.stringify(sel)}^@^type=fxgj`;
              code = Base64.encode(code);
              var url = `${window.location.origin}/#/viewModel?Code=${code}`;
              layer.alert(
                url,
                {
                  title: "分享链接",
                  btn: ["点击复制"],
                },
                function () {
                  const input = document.createElement("input");
                  document.body.appendChild(input);
                  input.setAttribute("value", url);
                  input.setAttribute("id", url);
                  input.select();
                  if (document.execCommand("copy")) {
                    document.execCommand("copy");
                    layer.msg("复制成功");
                  }
                  document
                    .getElementById(url)
                    .parentNode.removeChild(document.getElementById(url));
                }
              );
            },
          });
        }
      });
    },

    copyToClipboard(text) {
      if (text == "window") text = window.location.origin;
      var textarea = document.createElement("textarea");
      textarea.style.position = "fixed";
      textarea.style.opacity = 0;
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制成功");
    },
    // 查询列表
    fuzzyQuery() {
      if (this.search.trim() == "") this.pzList = this.AllPzList;
      else
        this.pzList = this.AllPzList.filter((item) =>
          item.description.includes(this.search)
        );
    },
    //点击图片还原视点
    resview(item) {

      // if (this.pdfDoc) {
      //   this.jumpToPage(item.position);
      // }

      if (this.viewer) {
        if (this.model2dpath && item.f2d && this.model2dpath !== item.f2d) {
          this.model2dpath = item.f2d;
          this.change2d();
          setTimeout(() => {
            //恢复视点
            try {
              bimViewPointNew.toolPanel.setVisible(false);
              bimViewPointNew.count = 0;
            } catch (error) { }
            var jsonObject = JSON.parse(item.view.replace(/'/g, '"'));
            this.viewer.restoreState(jsonObject);
            setTimeout(() => {
              var viewer = this.viewer;
              //定义涂鸦等
              viewer.unloadExtension("Autodesk.Viewing.MarkupsCore");
              viewer.loadExtension("Autodesk.Viewing.MarkupsCore").then(() => {
                var config = {
                  markupDisableHotkeys: false,
                };
                bimViewPointNew.markup =
                  new Autodesk.Viewing.Extensions.Markups.Core.MarkupsCore(
                    viewer,
                    config
                  );
                bimViewPointNew.markup.load();
                bimViewPointNew.enterViewMode();
                viewer.unloadExtension(
                  "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
                );
                viewer.loadExtension(
                  "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
                );
                bimViewPointNew.toolPanel =
                  viewer.loadedExtensions[
                    "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
                  ].getToolPanel();


                var markup = item.markup;

                var markupList = new Array();
                bimViewPointNew.markup.show();
                if (JSON.parse(markup).markupsSvg) {
                  this.initDwgTuya();
                  window.importAnnotationsFromJSON(markup);
                }
                else {
                  if (markup && markup.replace(/(^\s*)|(\s*$)/g, "").length > 0) {
                    markupList = markup.split("@#@");
                    if (markupList != null && markupList.length > 0) {
                      for (var i = 0, l = markupList.length; i < l; i++) {
                        var singleMarkup = markupList[i].split("@BIM@");
                        bimViewPointNew.markup.loadMarkups(
                          singleMarkup[1].replace(/'/g, '"'),
                          singleMarkup[0]
                        );
                      }
                    }
                  }
                }
                try {
                  document.getElementsByClassName("docking-markup")[0].style.display = "none";
                  document.getElementById("guiviewer3d-toolbar").style.display = "block";

                } catch (error) { }
              });

            }, 500);
          }, 1000);
        } else {
          //恢复视点
          try {
            bimViewPointNew.toolPanel.setVisible(false);
            bimViewPointNew.count = 0;
          } catch (error) { }
          var jsonObject = JSON.parse(item.view.replace(/'/g, '"'));
          this.viewer.restoreState(jsonObject);

          setTimeout(() => {
            var viewer = this.viewer;
            //定义涂鸦等
            viewer.unloadExtension("Autodesk.Viewing.MarkupsCore");
            viewer.loadExtension("Autodesk.Viewing.MarkupsCore").then(() => {
              var config = {
                markupDisableHotkeys: false,
              };
              bimViewPointNew.markup =
                new Autodesk.Viewing.Extensions.Markups.Core.MarkupsCore(
                  viewer,
                  config
                );
              bimViewPointNew.markup.load();
              bimViewPointNew.enterViewMode();
              viewer.unloadExtension(
                "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
              );
              viewer.loadExtension(
                "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
              );
              bimViewPointNew.toolPanel =
                viewer.loadedExtensions[
                  "Autodesk.ADN.Viewing.Extension.MarkupTool.NewEdition"
                ].getToolPanel();

              var markup = item.markup;

              var markupList = new Array();
              bimViewPointNew.markup.show();

              try {
                this.initDwgTuya();
                window.importAnnotationsFromJSON(markup);
              } catch (error) {
                if (markup && markup.replace(/(^\s*)|(\s*$)/g, "").length > 0) {
                  markupList = markup.split("@#@");
                  if (markupList != null && markupList.length > 0) {
                    for (var i = 0, l = markupList.length; i < l; i++) {
                      var singleMarkup = markupList[i].split("@BIM@");
                      bimViewPointNew.markup.loadMarkups(
                        singleMarkup[1].replace(/'/g, '"'),
                        singleMarkup[0]
                      );
                    }
                  }
                }
              }



              try {
                document.getElementsByClassName("docking-markup")[0].style.display = "none";
                document.getElementById("guiviewer3d-toolbar").style.display = "block";
              } catch (error) { }
            });
          }, 500);
        }
      }
    },
    // 批注详情活动页
    tabsClick(tab, name) {
      if (this.activeName == "second") {
        let params = { commentId: this.activeItem.id };
        GetCommentRecord({ params }).then((res) => {
          this.RecordList = res.Data;
        });
      }
    },
    // 批注详情回复
    postMessage() {
      if (this.reply == "") {
        this.$message.error(this.$t("common.请输入内容"));
        return;
      } else {
        let params = { commentId: this.activeItem.id, content: this.reply };
        AddCommentRecord(params).then((res) => {
          this.$message.success(this.$t("common.处理成功"));
          this.reply = "";
        });
      }
    },
    // 更新批注列表状态
    updateStatus(state, item, index) {
      let params = { commentId: item.id, state };
      ChangeCommentState(params).then((res) => {
        this.$message.success(this.$t("common.处理成功"));
        this.activeListIndex = index;
        this.GetCommentList();
      });
    },
    // 删除批注列表的信息
    delComment(item) {
      DelComment({ id: item.id }).then((res) => {
        this.$message.success(this.$t("common.处理成功"));
        this.GetCommentList();
      });
    },
    GetCommentList() {
      let params = { fileId: this.form.fileId };
      GetComment({ params }).then((res) => {
        this.pzList = res.Data;
        this.AllPzList = res.Data;
      });
    },
    // 批注点击关联文件
    handlePreviewInfo(file) {
      const a = document.createElement("a");
      a.href = this.$store.state.baseUrl + file.url;
      a.download = file.name; // 设置默认文件名
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    /**
     * 将扁平数据构建成树形结构，并清理空的 children 字段
     * @param {Array} flatData - 扁平数据数组
     * @param {String} idField - 节点唯一标识字段名
     * @param {String} parentIdField - 父节点标识字段名
     * @returns {Array} 树形结构数组
     */
    buildTree(flatData, idField = "id", parentIdField = "parentId") {
      const map = {};
      const tree = [];

      // 构建映射关系
      flatData.forEach((item) => {
        map[item[idField]] = { ...item, children: [] };
      });

      // 构建树结构
      flatData.forEach((item) => {
        const id = item[idField];
        const parentId = item[parentIdField];

        if (parentId && map[parentId]) {
          map[parentId].children.push(map[id]);
        } else {
          tree.push(map[id]);
        }
      });

      // 清理空的 children 字段
      function removeEmptyChildren(node) {
        if (node.children && node.children.length === 0) {
          delete node.children;
        } else if (node.children) {
          node.children.forEach(removeEmptyChildren);
        }
      }

      tree.forEach(removeEmptyChildren);

      return tree;
    },
    fileOnChange(value) {
      const nodes = this.$refs.myCascader.getCheckedNodes(true);
      if (nodes.length) {
        nodes
          .map((node) => node.data)
          .forEach((data) => {
            if (this.form.files.every((item) => item.name !== data.Name)) {
              this.form.files.push({
                name: data.Name,
                url: data.url,
                type: 2,
              });
            }
          });
      } else {
        const deletedNodes = this.$refs.myCascader.checkedNodes.filter(
          (node) => !value.includes(node.value)
        );
        deletedNodes
          .map((node) => node.data)
          .forEach((data) => {
            this.form.files = this.form.files.filter(
              (item) => item.name !== data.Name
            );
          });
      }
    },
    GetDeptWithUser2() {
      let params = { xid: this.locationParams.xid };
      GetDeptWithUser2({ params }).then((res) => {
        if (res.Data)
          this.userList = this.buildTree(res.Data, "Id", "ParentId");
      });
    },
    GetFileTreeWithFiles() {
      let params = { xid: this.locationParams.xid };
      GetFileTreeWithFiles({ params }).then((res) => {
        if (res.Data)
          this.fileList = this.buildTree(res.Data, "Id", "ParentId");
      });
    },
    GetCheckList() {
      // GetCheckList().then((res) => {
      //   this.checkList = this.buildTree(res.Data, "id", "parentid");
      //   console.log(this.checkList, "this.checkList");
      // });
      this.checkList = localStorage.lang == 'zh' ? kte_checklist_zh : kte_checklist_en;
    },
    screenshotToggle() {
      $(".dialog").toggle(); // 自动切换显示/隐藏状态
      $(".file_icon_container").toggle(); // 自动切换显示/隐藏状态
      $("#guiviewer3d-toolbar").toggle(); // 自动切换显示/隐藏状态
    },
    async screenshot() {
      this.screenshotToggle();
      // new kscreenshot({}).startScreenShot()

      setTimeout(() => {
        new ScreenShot({
          // enableWebRtc: (this.videoShow || this.officeShow) ? true : false,     // 启用 WebRTC 模式（需 HTTPS）
          // enableWebRtc: window.location.href.includes("https") ? false : true,     // 启用 WebRTC 模式（需 HTTPS）
          enableWebRtc: true,
          level: 99999, // 截图容器层级
          logging: false,
          scale: window.devicePixelRatio * 2, // 适配高清屏
          useCORS: true, // 允许跨域资源
          loadCrossImg: true,
          allowTaint: true, // 处理外部字体
          completeCallback: (data) => {
            this.downloadImage(data.base64);
            this.screenshotToggle();
          },
          closeCallback: () => {
            this.screenshotToggle();
          },
          cancelCallback: () => {
            this.screenshotToggle();
          },
          triggerCallback: (data) => { },
        });
      }, 500);


    },
    downloadImage(dataUrl) {
      var data_mark = null;
      if (this.modelShow && bimViewPointNew.markup) {
        var markup_id = bimViewPointNew.randomWord(true, 16, 32);
        var markString = bimViewPointNew.markup
          .generateData()
          .replace(/\"/g, "'");
        if (
          markString != null &&
          markString.replace(/(^\s*)|(\s*$)/g, "").length > 0
        ) {
          data_mark += markup_id + "@BIM@" + markString;
        }
      }

      var filedata = {
        name:
          new Date().toLocaleDateString() +
          "_" +
          new Date().toLocaleTimeString() +
          "截图",
        url: dataUrl,
        view: this.viewer ? JSON.stringify(this.viewer.getState()) : null,
        markup: data_mark,
        f2d: this.model2dpath,
        type: 1,
        // position: this.pdfDoc ? this.currentPage : null,
      };
      if (this.locationParams.path
        .substring(this.locationParams.path.lastIndexOf(".") + 1)
        .toLowerCase() == "dwg") {
        var markupd = window.exportAnnotations();
        if (markupd)
          filedata.markup = markupd;
      }
      this.form.files.push(filedata)
    },
    // 关闭自定义弹出框
    resetForm(val) {
      try {
        bimViewPointNew.toolPanel.setVisible(false);
        bimViewPointNew.count = 0;
      } catch (error) { }
      this.mydialogVisible = val ? val : false;
      this.form = this.$options.data.call(this).form;
      this.cascaderModel = this.$options.data.call(this).cascaderModel;
      this.form.xid = this.locationParams.xid;
      this.form.fileId = this.locationParams.fileId;
    },
    removeEmptyProperties(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          // 判断是否为空值：null, undefined, 空字符串, 字符串"null"
          if (
            value === null ||
            value === undefined ||
            value === "" ||
            value === "null" ||
            value === "undefined"
          ) {
            delete obj[key];
          }
        }
      }
      return obj;
    },

    submitFormContinue1() {
      var _this = this;
      var setin = setInterval(() => {
        if (_this.isFinishMultiDrawing) {
          _this.isFinishMultiDrawing = false;
          clearInterval(setin);
          _this.submitFormContinue2()
        }
      }, 100);
    },
    submitFormContinue2() {
      window.captureScreenshot()
      setTimeout(() => {
        // 创建FormData对象
        const formdata = new FormData();
        //把this.form.files 删掉属性数据为空或者null
        if (this.form.files && this.form.files.length > 0)
          this.form.files.forEach((file) => {
            this.removeEmptyProperties(file);
          });

        this.appendFormData(formdata, this.form);
        AddComment(formdata).then((res) => {
          this.$message({
            message: this.$t("common.处理成功"),
            type: "success",
          });
          this.resetForm();
        });
      }, 1000);

    },

    // 提交弹出框表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.viewer) {
            this.mydialogVisible = false;
            window.startMultiDrawingLine();
            this.submitFormContinue1();
            return;
          }

          // window.captureScreenshot()
          // 创建FormData对象
          const formdata = new FormData();
          //把this.form.files 删掉属性数据为空或者null
          if (this.form.files && this.form.files.length > 0)
            this.form.files.forEach((file) => {
              this.removeEmptyProperties(file);
            });

          this.appendFormData(formdata, this.form);
          AddComment(formdata).then((res) => {
            this.$message({
              message: this.$t("common.处理成功"),
              type: "success",
            });
            this.resetForm();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    hoverImage1(e) {
      e.target.src = "/img/ktr_icon/file_icon/active_pz.png";
    },
    hoverImage2(e) {
      e.target.src = "/img/ktr_icon/file_icon/active_lb.png";
    },
    leaveImage1(e) {
      if (!this.mydialogVisible)
        e.target.src = "/img/ktr_icon/file_icon/pz.png";
    },
    leaveImage2(e) {
      if (!this.mydialogVisible2)
        e.target.src = "/img/ktr_icon/file_icon/lb.png";
    },
    viewers(url) {
      console.log(url);
      var Params = this.locationParams,
        _this = this;
      //初始化
      var config = {
        extensions: ["Autodesk.Viewing.ZoomWindow"],
        disabledExtensions: {
          measure: false,
          section: false,
        },
        memory: {
          limit: 32 * 1024, //32 GB
        },
        theme: "light-theme",
      };
      var myViewerDiv = document.getElementById("MyViewerDiv");
      _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
        myViewerDiv,
        config
      );
      var options = {
        document: url,
        language:
          localStorage.lang == "zh" ? "zh-HANS" : "en",
        env: "Local",
        offline: "true",
        useADP: false,
      };
      Autodesk.Viewing.Initializer(options, function onInitialized() {
        _this.viewer.start();
        _this.viewer.loadModel(options.document, {
          isAEC: true,
        });
        _this.viewer.addEventListener(
          Autodesk.Viewing.TEXTURES_LOADED_EVENT,
          function (event) {
            // _this.viewerFunctions();
            _this.viewer.setSwapBlackAndWhite(true);
            _this.viewer.setBackgroundColor(17, 24, 32, 17, 24, 32);
          }
        );
      });
    },
    click_pz() {
      try {
        document.getElementsByName("cancel")[0].nextElementSibling.click()
      } catch (error) { }
      this.mydialogVisible = !this.mydialogVisible;
      if (this.mydialogVisible && this.viewer) {
        this.tuya()
      }
    },
    click_lb() {
      this.mydialogVisible2 = !this.mydialogVisible2;
    },
    //删除问题截图上传的图片
    handleRemove(file, files) {
      this.form.files = files;
    },
    handleRemove2(file, files) {
      this.cascaderModel = this.form.files
        .filter((item) => item.type == 2 && item.name != file.name)
        .map((item) => item.name);
      this.form.files = this.form.files.filter(
        (item) => item.name != file.name
      );
    },
    //问题截图上传图片
    handleChange(file, files) {
      this.form.files = files;
    },
    handleChange2(file, files) {
      this.form.files.push({
        name: file.name,
        url: file.raw,
        type: 2,
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.lookImgDialog = true;
    },
    visible() {
      this.mydialogVisible = false;
    },
    appendFormData(formData, data, parentKey = "") {
      if (data && typeof data === "object" && !(data instanceof File)) {
        Object.keys(data).forEach((key) => {
          const value = data[key];
          const combinedKey = parentKey ? `${parentKey}[${key}]` : key;

          if (Array.isArray(value)) {
            if (value.every((item) => typeof item === "string")) {
              formData.append(key, value.join(","));
            } else {
              value.forEach((item, index) => {
                if (item.url instanceof File) {
                  formData.append(`localStorageFile[${index}]`, item.url);
                } else
                  this.appendFormData(
                    formData,
                    item,
                    `${combinedKey}[${index}]`
                  );
              });
            }
          } else if (typeof value === "object" && value !== null) {
            this.appendFormData(formData, value, combinedKey);
          } else {
            formData.append(combinedKey, value);
          }
        });
      } else {
        formData.append(parentKey, data);
      }
    },
    // 打开批注详情
    openParticulars(item, index) {
      this.activeItem = item;
      this.activeListIndex = index;
      this.mydialogVisible3 = true;
      if (item.files && item.files.length > 0)
        this.resview(item.files[0]);
    },

    // pdf方法
    async loadPdf() {
      const loadingTask = pdfjsLib.getDocument(this.iframeUrl);
      this.pdfDoc = await loadingTask.promise;
      this.totalPages = this.pdfDoc.numPages;
      await this.renderAllPages();
      this.updateButtons();
    },
    // 渲染所有页面
    async renderAllPages() {
      const content = document.getElementById('pdfContent');
      content.innerHTML = '';

      for (let i = 1; i <= this.totalPages; i++) {
        await this.renderPage(i);
      }

      this.setupScrollListener();
    },
    // 渲染单个页面
    async renderPage(pageNumber) {
      const page = await this.pdfDoc.getPage(pageNumber);
      const viewport = page.getViewport({
        scale: this.zoomSelect
      });

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      const pageDiv = document.createElement('div');
      pageDiv.className = 'pdf-page';
      pageDiv.dataset.pageNumber = pageNumber;
      pageDiv.appendChild(canvas);

      document.getElementById('pdfContent').appendChild(pageDiv);

      await page.render({
        canvasContext: ctx,
        viewport: viewport
      }).promise;
    },
    // 设置滚动监听
    setupScrollListener() {
      const container = document.getElementById('pdfContainer');
      let scrollTimeout;

      container.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(this.updateCurrentPage, 100);
      });
    },
    // 更新当前页码
    updateCurrentPage() {
      const container = document.getElementById('pdfContainer');
      const pages = document.querySelectorAll('.pdf-page');
      const containerRect = container.getBoundingClientRect();
      const containerTop = containerRect.top;

      let visiblePage = 1;
      let minDistance = Infinity;

      pages.forEach(page => {
        const pageRect = page.getBoundingClientRect();
        const distance = Math.abs(pageRect.top - containerTop);

        if (distance < minDistance) {
          minDistance = distance;
          visiblePage = parseInt(page.dataset.pageNumber);
        }
      });

      if (this.currentPage !== visiblePage) {
        this.currentPage = visiblePage;
        this.updateButtons();
      }
    },
    // 上一页
    prevPage() {
      if (this.currentPage > 1) {
        this.jumpToPage(this.currentPage - 1);
      }
    },
    // 下一页
    nextPage() {
      if (this.pdfDoc && this.currentPage < this.pdfDoc.numPages) {
        this.jumpToPage(this.currentPage + 1);
      }
    },
    // 跳转到指定页面
    jumpToPage(pageNumber = null) {
      if (!pageNumber) {
        pageNumber = this.currentPage;
      }

      if (!this.pdfDoc || pageNumber < 1 || pageNumber > this.pdfDoc.numPages) {
        return;
      }

      const pageElement = document.querySelector(`[data-page-number="${pageNumber}"]`);
      if (pageElement) {
        pageElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        this.currentPage = pageNumber;
        this.updateButtons();
      }
    },

    // 改变缩放
    async changeZoom() {
      if (this.pdfDoc) {
        await this.renderAllPages();

        // 跳转回当前页
        this.jumpToPage(this.currentPage);
      }
    },

    // 更新按钮状态
    updateButtons() {
      this.prevDisable = !this.pdfDoc || this.currentPage <= 1;
      this.nextDisable = !this.pdfDoc || this.currentPage >= this.pdfDoc.numPages;
    }



  },
  created() {
    window.viewFileModelThis = this;
    // this.showTips = !window.location.href.includes("https");
    this.GetCheckList();
    this.uid = localStorage.id;
    // var _this = this;
    var search = window.location.hash
      .substr(1)
      .split("=")[1]
      .replace(/%3D/g, "=");
    search = Base64.decode(search).split("&");
    search.forEach((str) => {
      let name = str.slice(0, str.indexOf("="));
      let val = str.slice(str.indexOf("=") + 1);
      this.locationParams[name] = val;
    });
    this.form.xid = this.locationParams.xid;
    this.form.fileId = this.locationParams.fileId;
    this.GetFileTreeWithFiles();
    this.GetDeptWithUser2();
    //从批注列表过来
    if (this.locationParams.commentId) {
      this.click_lb();
      var interval = setInterval(() => {
        if (this.pzList.length) {
          clearInterval(interval);
          var item = this.pzList.filter(
            (x) => x.id == this.locationParams.commentId
          )[0];
          this.activeListIndex = this.pzList.findIndex((item2) => {
            // 根据对象的唯一标识（如 id）进行判断
            return item2.id === item.id;
          });
          this.openParticulars(item, this.activeListIndex);
        }
      }, 100);
    }
  },
  async mounted() {
    //判断文件类型
    var ext = this.locationParams.path
      .substring(this.locationParams.path.lastIndexOf(".") + 1)
      .toLowerCase();
    if (this.exts.indexOf(ext) > -1) {
      if (ext == "pdf") {
        this.iframeShow = true;
        this.iframeUrl = this.$store.state.baseUrl + this.locationParams.path; // 文档URL
        // this.loadPdf();
      } else if (
        ext == "pdf" ||
        ext == "txt" ||
        ext == "doc" ||
        ext == "docx" ||
        ext == "xls" ||
        ext == "CSV" ||
        ext == "xlsx" ||
        ext == "ppt" ||
        ext == "pptx"
      ) {
        this.officeShow = true;
        let documentType = "";
        if (ext == "pdf" || ext == "txt" || ext == "doc" || ext == "docx") {
          documentType = "word";
        } else if (ext == "xls" || ext == "xlsx" || ext == "CSV") {
          documentType = "cell";
        } else if (ext == "ppt" || ext == "pptx") {
          documentType = "slide";
        }
        let config = {
          document: {
            token:
              "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudCI6eyJkaXJlY3RVcmwiOiIiLCJmaWxlVHlwZSI6InBkZiIsImluZm8iOnsib3duZXIiOiJNZSIsInVwbG9hZGVkIjoiVHVlIEF1ZyAxOSAyMDI1IiwiZmF2b3JpdGUiOm51bGx9LCJrZXkiOiIxMTYuMjMxLjEyOS41MkFVVE9JRF9VVG91Y2hfQ19fX19fX1YxLjcucGRmMTc1NTYwMjEzMTIxNSIsInBlcm1pc3Npb25zIjp7ImNoYXQiOnRydWUsImNvbW1lbnQiOmZhbHNlLCJjb3B5Ijp0cnVlLCJkb3dubG9hZCI6dHJ1ZSwiZWRpdCI6dHJ1ZSwiZmlsbEZvcm1zIjpmYWxzZSwibW9kaWZ5Q29udGVudENvbnRyb2wiOnRydWUsIm1vZGlmeUZpbHRlciI6dHJ1ZSwicHJpbnQiOnRydWUsInJldmlldyI6ZmFsc2UsInJldmlld0dyb3VwcyI6bnVsbCwiY29tbWVudEdyb3VwcyI6e30sInVzZXJJbmZvR3JvdXBzIjpudWxsLCJwcm90ZWN0Ijp0cnVlfSwicmVmZXJlbmNlRGF0YSI6eyJmaWxlS2V5Ijoie1wiZmlsZU5hbWVcIjpcIkFVVE9JRCBVVG91Y2goQynkvb_nlKjor7TmmI7kuaZWMS43LnBkZlwiLFwidXNlckFkZHJlc3NcIjpcIjExNi4yMzEuMTI5LjUyXCJ9IiwiaW5zdGFuY2VJZCI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZSJ9LCJ0aXRsZSI6IkFVVE9JRCBVVG91Y2goQynkvb_nlKjor7TmmI7kuaZWMS43LnBkZiIsInVybCI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZS9kb3dubG9hZD9maWxlTmFtZT1BVVRPSUQlMjBVVG91Y2goQyklRTQlQkQlQkYlRTclOTQlQTglRTglQUYlQjQlRTYlOTglOEUlRTQlQjklQTZWMS43LnBkZiZ1c2VyYWRkcmVzcz0xMTYuMjMxLjEyOS41MiJ9LCJkb2N1bWVudFR5cGUiOiJwZGYiLCJlZGl0b3JDb25maWciOnsiYWN0aW9uTGluayI6bnVsbCwiY2FsbGJhY2tVcmwiOiJodHRwOi8vOC4xNTMuMTc1LjIwMDo4MDExL2V4YW1wbGUvdHJhY2s_ZmlsZW5hbWU9QVVUT0lEJTIwVVRvdWNoKEMpJUU0JUJEJUJGJUU3JTk0JUE4JUU4JUFGJUI0JUU2JTk4JThFJUU0JUI5JUE2VjEuNy5wZGYmdXNlcmFkZHJlc3M9MTE2LjIzMS4xMjkuNTIiLCJjb0VkaXRpbmciOm51bGwsImNyZWF0ZVVybCI6bnVsbCwiY3VzdG9taXphdGlvbiI6eyJhYm91dCI6dHJ1ZSwiY29tbWVudHMiOnRydWUsImNsb3NlIjp7InZpc2libGUiOmZhbHNlfSwiZmVlZGJhY2siOnRydWUsImZvcmNlc2F2ZSI6ZmFsc2UsImdvYmFjayI6eyJibGFuayI6ZmFsc2UsInVybCI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZSJ9LCJzdWJtaXRGb3JtIjpmYWxzZX0sImVtYmVkZGVkIjp7ImVtYmVkVXJsIjoiaHR0cDovLzguMTUzLjE3NS4yMDA6ODAxMS9leGFtcGxlL2Rvd25sb2FkP2ZpbGVOYW1lPUFVVE9JRCUyMFVUb3VjaChDKSVFNCVCRCVCRiVFNyU5NCVBOCVFOCVBRiVCNCVFNiU5OCU4RSVFNCVCOSVBNlYxLjcucGRmIiwic2F2ZVVybCI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZS9kb3dubG9hZD9maWxlTmFtZT1BVVRPSUQlMjBVVG91Y2goQyklRTQlQkQlQkYlRTclOTQlQTglRTglQUYlQjQlRTYlOTglOEUlRTQlQjklQTZWMS43LnBkZiIsInNoYXJlVXJsIjoiaHR0cDovLzguMTUzLjE3NS4yMDA6ODAxMS9leGFtcGxlL2Rvd25sb2FkP2ZpbGVOYW1lPUFVVE9JRCUyMFVUb3VjaChDKSVFNCVCRCVCRiVFNyU5NCVBOCVFOCVBRiVCNCVFNiU5OCU4RSVFNCVCOSVBNlYxLjcucGRmIiwidG9vbGJhckRvY2tlZCI6InRvcCJ9LCJmaWxlQ2hvaWNlVXJsIjoiIiwibGFuZyI6ImVuIiwibW9kZSI6InZpZXciLCJwbHVnaW5zIjp7InBsdWdpbnNEYXRhIjpbXX0sInRlbXBsYXRlcyI6bnVsbCwidXNlciI6eyJncm91cCI6IiIsImlkIjoidWlkLTEiLCJpbWFnZSI6Imh0dHA6Ly84LjE1My4xNzUuMjAwOjgwMTEvZXhhbXBsZS9pbWFnZXMvdWlkLTEucG5nIiwibmFtZSI6IkpvaG4gU21pdGgiLCJyb2xlcyI6bnVsbH19LCJoZWlnaHQiOiIxMDAlIiwidG9rZW4iOiIiLCJ0eXBlIjoiZGVza3RvcCIsIndpZHRoIjoiMTAwJSIsImlhdCI6MTc1NTYwMjI5NCwiZXhwIjoxNzU1NjAyNTk0fQ.JrvZ3Aa8fIxZ-f9e7WcecI_MF65XyBUvcp0SwJSal8A",
            fileType: ext,
            title: this.locationParams.name,
            url: this.$store.state.baseUrl + this.locationParams.path, // 文档URL
            permissions: {
              // 关闭所有权限
              edit: false,
              download: false,
              print: false,
              review: false,
              fillForms: false,
              comment: false,
            },
          },
          documentType: documentType,
          editorConfig: {
            lang: "zh", // 设置为中文
            mode: "view", // 强制设为查看模式
            user: {
              id: "viewer-1",
              name: "查看者",
            },
            customization: {
              hideLogo: true, // 直接隐藏logo
            },
          },
          height: "100%",
          width: "100%",
        };
        function generateOnlyOfficeToken(payload, secret) {
          // Header 部分
          const header = {
            alg: "HS256", // 算法：OnlyOffice 使用 HS256
            typ: "JWT",
          };

          // 将 Header 和 Payload 转换为 Base64Url 字符串
          const sHeader = JSON.stringify(header);
          const sPayload = JSON.stringify(payload);

          // 使用 jsrsasign 库生成 Token
          const sJWT = KJUR.jws.JWS.sign("HS256", sHeader, sPayload, secret);

          return sJWT;
        }

        // 使用方法
        const yourSecret = "8v6evC2ITvNw0nlAtS7TUJzeiDtSNV"; // 你的 OnlyOffice 密钥

        const jwtToken = generateOnlyOfficeToken(config, yourSecret);

        config.document.token = jwtToken;

        new DocsAPI.DocEditor("editor", config);
      } else if (ext == "mp4") {
        this.videoShow = true;
        this.iframeUrl = this.$store.state.baseUrl + this.locationParams.path;
      } else if (
        ext == "jpg" ||
        ext == "png" ||
        ext == "gif" ||
        ext == "jpeg"
      ) {
        this.imgShow = true;
        this.iframeUrl = this.$store.state.baseUrl + this.locationParams.path;
      }
    } else if (this.modelexts.indexOf(ext) == -1 && this.exts.indexOf(ext) == -1) {
      this.$message({
        type: "error",
        message: this.$t("common.暂不支持查看该类型文件"),
      });
    }

    else {
      //模型文件
      let params = { guid: this.locationParams.guid };
      let res = await GetOneUploadFile({ params });
      this.OneUploadFileData = res.Data;
      if (res.Data) {
        //状态（0 转换中 1转换失败 2转换成功）
        if (res.Data.modelstate && res.Data.modelstate.mdst05 == 2) {
          this.modelShow = true;
          if (res.Data.file.prfl04.includes("dwg")) {
            //dwg单独处理
            this.model2d = res.Data.model2d;
            this.model2dpath = res.Data.model2d[0].tdmd04;
            this.url = this.$store.state.baseUrl + this.model2dpath;
            this.viewers(this.url);
          } else
            this.viewers(this.$store.state.baseUrl + res.Data.model.mode09);
        } else {
          this.$message({
            type: "error",
            message: !res.Data.modelstate
              ? this.$t("common.请先进行模型转换")
              : res.Data.modelstate.mdst05 == 0
                ? this.$t("common.转换中")
                : res.Data.modelstate.mdst05 == 1
                  ? this.$t("common.转换失败")
                  : this.$t("common.转换成功"),
          });
        }
      }
    }
  },
  watch: {
    mydialogVisible: {
      handler(newVal, oldVal) {
        if (newVal) {
          $(".icon_1").attr("src", "/img/ktr_icon/file_icon/active_pz.png");
          $(".icon_2").attr("src", "/img/ktr_icon/file_icon/lb.png");
          this.mydialogVisible2 = false;
        } else {
          $(".icon_1").attr("src", "/img/ktr_icon/file_icon/pz.png");
          // this.resetForm();
        }
      },
      deep: true,
    },
    mydialogVisible2: {
      handler(newVal, oldVal) {
        if (newVal) {
          $(".icon_2").attr("src", "/img/ktr_icon/file_icon/active_lb.png");
          $(".icon_1").attr("src", "/img/ktr_icon/file_icon/pz.png");
          this.mydialogVisible = false;
          this.GetCommentList();
        } else {
          this.mydialogVisible3 = false;
          this.activeItem = null;
          $(".icon_2").attr("src", "/img/ktr_icon/file_icon/lb.png");
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import url("../../public/Content/css/style.css");

/* 弹窗样式 */
#cloudInputModal {
  display: none;
  position: fixed;
  z-index: 10000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  min-width: 300px;
}

#cloudInputModal.show {
  display: block;
}

#cloudInputModal h3 {
  margin-top: 0;
  margin-bottom: 15px;
}

#cloudInputModal input {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

#cloudInputModal .button-group {
  text-align: right;
}

#cloudInputModal button {
  padding: 8px 20px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#cloudInputModal .btn-confirm {
  background-color: #4CAF50;
  color: white;
}

#cloudInputModal .btn-cancel {
  background-color: #f44336;
  color: white;
}

#cloudInputModal .btn-confirm:hover {
  background-color: #45a049;
}

#cloudInputModal .btn-cancel:hover {
  background-color: #da190b;
}

/deep/ #pdfShow {
  background: #2c3e50;
  color: white;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .controls {
    background: #34495e;
    //padding: 15px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    margin-bottom: 2px;
    flex-wrap: wrap;
    position: relative;
  }

  .pdf-container {
    flex: 1;
    background: #525659;
    border-radius: 8px;
    overflow: auto;
    position: relative;
    height: 100%;
  }

  .pdf-content {
    // padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .pdf-page {
    // margin: 10px;
    // width: 100%;
    // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    // background: white;
    background: #525659;
    width: 100%;
    text-align: center
  }
}

/deep/ .docking-panel,
.docking-markup {
  position: absolute;
  bottom: 80px;
}

.home {
  width: 100%;
  height: 100%;
  position: relative;

  #editor {
    width: 100%;
    height: 100vh;
  }

  #myVideo {
    position: absolute;
    left: 30%;
    top: 0;
  }

  // /deep/ iframe {
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  // }

  .el-cascader {
    width: 100%;
  }

  .dialog2 {
    /deep/ .el-descriptions__header {
      margin-bottom: 15px !important;
    }

    /deep/ .el-descriptions {
      margin-bottom: 8px;
      // background-color: #ebf9ff;
      padding: 8px;
      border-radius: 6px;
    }

    .activeList {
      background-color: #ebf9ff !important;
    }

    .inactivityList {
      background-color: #f5f5f5 !important;
    }

    /deep/ .el-descriptions__body {
      background-color: transparent;
    }
  }

  /deep/ .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }

  /deep/ .el-descriptions-item__content {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .line {
    height: 1px;
    width: 100%;
    background-color: rgb(226, 226, 226);
    margin: 10px 0;
  }
}

/deep/ .el-upload {
  display: none !important;
}

.icon_1,
.icon_2 {
  cursor: pointer;
}

.file_icon_container {
  position: absolute;
  z-index: 99;
  width: 140px;
  padding: 10px;
  height: 30px;
  background-color: #ffffff;
  box-shadow: 1px 3px 10px 0 rgba(0, 0, 0, 0.5);
  left: 70%;
  bottom: 15px;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  cursor: move;
}

.flexLR {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.model {
  position: fixed;
  width: 100%;
  height: 100%;
}

.iframecss {
  position: fixed;
  /* 固定定位 */
  top: 0;
  left: 0;
  width: 100vw;
  /* 占满视口宽度 */
  height: 100vh;
  /* 占满视口高度 */
  border: none;
  /* 去除默认边框 */
  // z-index: 99;
  /* 确保在其他元素之上 */
}

/deep/ .el-upload--picture-card {
  width: 75px;
  height: 75px;
  line-height: 75px;
}

/deep/ .myupload {
  .el-upload-list__item {
    width: 75px;
    height: 75px;
    line-height: 75px;
  }
}
</style>
